var opend_pop;
const isProduct = window.location.href.indexOf("/product");
var is_first_load = 0;

var baseURL = "https://services1.stevemadden.com/";
jQuery(function () {
  jQuery("body").on("change", ".swatch:not(.select_color) :radio", function () {
    var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
    // if (analytics_pdp_AB == 'a:1') {
    var currentSize = $(
      ".new_custom_swatch_Size .swatch-element input:checked"
    ).val();
    ManageCookie("selected_size", currentSize);
    // }
  });
});

var getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

var ManageCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

// if (typeof getCookie("selected_size") !== 'undefined' && getCookie("selected_size") != '' && analytics_pdp_AB == 'a:1') {
if (
  typeof getCookie("selected_size") !== "undefined" &&
  getCookie("selected_size") != ""
) {
  setTimeout(function () {
    var val = getCookie("selected_size");
    if (
      $('.new_custom_swatch_Size .swatch-element input[value="' + val + '"]')
        .length
    ) {
      var optionIndex = $(
        '.new_custom_swatch_Size .swatch-element input[value="' + val + '"]'
      )
        .closest(".swatch")
        .attr("data-option-index");
      var optionValue = $(
        '.new_custom_swatch_Size .swatch-element input[value="' + val + '"]'
      ).val();
      $('.new_custom_swatch_Size .swatch-element input[value="' + val + '"]')
        .closest("form")
        .find(".single-option-selector")
        .eq(optionIndex)
        .val(optionValue)
        .prop("checked", true)
        .trigger("change");
      $("#add-to-cart").removeAttr("disabled");
    }
  }, 1000);
}

//Free Gift Start
const ADD_OPERATION = "ADD";
const CHANGE_OPERATION = "CHANGE";
const UPDATE_OPERATION = "UPDATE";
const CART_TYPE = "CART";
const CART_HTML_TYPE = "CART_HTML";

function performCartOperation(
  cartData,
  callback,
  operationType = ADD_OPERATION
) {
  var url = "/cart/add.js";
  var method = operationType.includes(CART_TYPE) ? "GET" : "POST";

  if (operationType === CHANGE_OPERATION) {
    url = "/cart/change.js";
  } else if (operationType === UPDATE_OPERATION) {
    url = "/cart/update.js";
  } else if (operationType === CART_TYPE) {
    url = "/cart.js";
  } else if (operationType === CART_HTML_TYPE) {
  }
  var requestOptions = {
    method: method,
    credentials: "same-origin",
    headers: {
      "Content-Type": operationType.includes("HTML")
        ? "text/html"
        : "application/json",
      "X-Requested-With": "xmlhttprequest",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: 0,
    },
    body: cartData && JSON.stringify(cartData),
  };

  return fetch(url, requestOptions)
    .then((response) => response.text())
    .then((data) => {
      var responseData = JSON.parse(data);
      // if (responseData.status) {
      //     throw new Error(responseData.description);
      // }
      callback();
    })
    .catch((error) => {
      console.error(error);
    });
}

function addCartItems(cartItems, callback) {
  return performCartOperation({ items: cartItems }, callback);
}

function updateCartItems(cartUpdates, callback) {
  return performCartOperation(
    { updates: cartUpdates },
    callback,
    UPDATE_OPERATION
  );
}

function isProductInCart(cartProduct, productId) {
  if (typeof cartProduct != "undefined") {
    return cartProduct.some(function (item) {
      return item.id === parseInt(productId, 10);
    });
  }
}
function addRemoveGiftsFromCart(callback) {
  if (
    window.GWP != undefined &&
    typeof window.GWP.product != "undefined" &&
    typeof window.GWP.product.error == "undefined"
  ) {
    $.get("/cart?view=proxy", function (data) {
      var data = JSON.parse(data);
      var cart = data.cart;
      var cartProduct = data.cart_product;
      var giftProduct = window.GWP.product;
      var giftStock = window.GWP.product_qty;
      var toAdd = [];
      var toRemove = [];
      var toUpdate = [];
      if (typeof cartProduct != "undefined" && cart.item_count > 0) {
        var checkNeedGift = cartProduct.filter(function (v, i) {
          return v.tags.indexOf(window.GWP.tag) > -1;
        });
        var baseId = [];
        $.each(checkNeedGift, function (i, v) {
          baseId.push(v.id);
        });
        var checkNeedCartGift = cart.items.filter(function (k, j) {
          return baseId.indexOf(k.product_id) > -1;
        });
        var isInCart = isProductInCart(cartProduct, giftProduct.id);
        var isGift = cart.items.filter(function (v, i) {
          return v.properties["_gift_product"] == "Yes";
        });
        if (
          checkNeedGift.length > 0 &&
          !isInCart &&
          giftStock > 0 &&
          getCookie("Gift") == ""
        ) {
          toAdd.push({
            quantity: 1,
            id: giftProduct.variants[0].id,
            properties: {
              _gift_product: "Yes",
            },
          });
        } else if (checkNeedGift.length > 0 && isInCart) {
          toUpdate.push(isGift[0]);
        } else if (checkNeedGift.length == 0 && isInCart) {
          toRemove.push(isGift[0]);
        }
        if (toAdd.length) {
          addCartItems(toAdd, callback);
        }
        if (toRemove.length) {
          const items = toRemove.reduce((accumulator, currentItem) => {
            accumulator[currentItem.key] = 0;
            return accumulator;
          }, {});
          updateCartItems(items, callback);
        }
        if (toUpdate.length) {
          var qty = 0;
          $.each(checkNeedCartGift, function (i, v) {
            qty = qty + v.quantity;
          });
          const items = toUpdate.reduce((accumulator, currentItem) => {
            accumulator[currentItem.key] = qty;
            return accumulator;
          }, {});
          if (giftStock > qty) {
            updateCartItems(items, callback);
          }
        }
      }
      if (toRemove.length == 0 && toAdd.length == 0) {
        callback();
      }
    });
  } else {
    callback();
  }
}
//Free Gift End

var wishlistButton = document.querySelectorAll(".swym-add-to-wishlist_custom");

for (var i = 0; i < wishlistButton.length; i++) {
  wishlistButton[i].addEventListener("click", function (event) {
    if ($(this).hasClass("swym-added")) {
      return true;
    }
    if (window.sm_theme.variable.not_customer == true) {
      $.ajax({
        url: "https://services.stevemadden.com/SwellWebhook/GetWishlist",
        data: {
          email: window.sm_theme.variable.customer_id,
          customer_id: window.sm_theme.variable.customer_id,
        },
        type: "POST",
        success: function (result) {},
        error: function (result) {},
      });
    }
  });
}

if (
  window.sm_theme.variable.not_customer == true &&
  window.sm_theme.variable.template_edit == true
) {
  $("#btnAccountResetPassword").on("click", function () {
    // This prevents the form from submitting
    event.preventDefault();
    if (window.international == false) {

      var password = $("#customer_password").val().trim();
      var rePassword = $("#customer_password_confirmation").val().trim();
      if (password && rePassword) {
        var param = {
          customerId: window.sm_theme.variable.customer_id,
          formname: "changepass",
          currentEmail: window.sm_theme.variable.customer_email,
          newPassword: $("#customer_password").val(),
          reNewPassword: $("#customer_password_confirmation").val(),
        };
        $.ajax({
          type: "POST",
          url: baseURL + "Responsys/UpdateCustomer",
          data: param,
          dataType: "json",
          crossDomain: true,
          success: function (json) {
            $(".updatepassmsg span").html(json.Message);
            $(".updatepassmsg span").delay(5000).fadeOut("slow");
          },
          error: function () {
            // ...  display Erro msg
          },
        });
      }
    }
  });

  $("body").on("click", "#updateemail", function (event) {
    // This prevents the form from submitting
    event.preventDefault();
    if (window.international == false) {
      // debugger;
      var email = $("#currentEmail").val().trim();
      var ne = $("#newEmail").val().trim();
      var rne = $("#reNewEmail").val().trim();
      var cemail = window.sm_theme.variable.customer_email;
      var emailReg = "";
      if (email && ne && rne && email == cemail && ne == rne) {
        var param = {
          customerId: window.sm_theme.variable.customer_id,
          formname: "changeemail",
          currentEmail: email,
          newEmailAddress: ne,
          reNewEmail: rne,
        };
        $.ajax({
          type: "POST",
          url: baseURL + "Responsys/UpdateCustomer",
          data: param,
          dataType: "json",

          success: function (json) {
            $(".updateemailmsg span").html(json.Message);
            $(".updateemailmsg span").delay(5000).fadeOut("slow");

            if (json.Status == 1) {
              window.location.reload();
            }
          },
          error: function () {
            // ...  display Erro msg
          },
        });
      } else {
        console.log("aaaaaaaaaaaaa");
      }
    }
  });
}

var cart_ref = 0;
$(function () {
  (siteNav = () => {
    const capitalize = (words) =>
      words
        .split(" ")
        .map(
          (w) =>
            w.toLowerCase().substring(0, 1).toUpperCase() +
            w.toLowerCase().substring(1)
        )
        .join(" ");

    $("#mainNavDesk .site-nav > li").each(function (i, e) {
      const $link = $(e).find(".site-nav__link ");

      if ($link.children("img.nav_image").length == 0) {
        if ($link.html().indexOf("Pre-Fall") == -1) {
          var text = capitalize($link.html());
          $link.html(text);
        } else {
          var text = $link.html();
          $link.html(text);
        }
      }
    });
    $(
      "#mainNavDesk .site-nav > .hasDropDown a:not(.menu_only_title, .stay_normal)"
    ).each(function (i, e) {
      const $link = $(e);

      if ($link.children("img").length == 0) {
        if ($link.html().indexOf("Pre-Fall") == -1) {
          var text = capitalize($link.html());
          $link.html(text);
        } else {
          var text = $link.html();
          $link.html(text);
        }
      }
    });

    if (window.innerWidth > 992) {
      let $topnavBanners = $(".topnav-banner");

      $topnavBanners.each(function (i, e) {
        let $banner = $(e);
        var img_alt = "";
        let $parent = $banner.parent();
        let src = $banner.attr("data-src");
        let alt = $banner.attr("data-alt");
        if (typeof alt !== "undefined" && alt !== false) {
          img_alt = $banner.attr("data-alt");
        }
        $banner.remove();

        if ($parent.find("img").length == 0)
          $(
            `<img data-src="${src}" alt="` +
              img_alt +
              `" class="hideOnMob"  loading="lazy" width="250" height="250"/>`
          ).appendTo($parent);
      });
    }
  })();

  var loadScript = function (url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  var newsLetterEvents = function ($) {

    var SubscribeNewsLetter = function () {
      $.ajax({
        type: "POST",
        url: baseURL + "Responsys/AddNewsLetter",
        data: {
          email: $("#moreAboutYou [name='email']").val().trim(),
          page: "Footer",
          newsletter: "",
          last_name: $("#moreAboutYou [name='Lname']").val(),
          gender_type: "",
          first_name: $("#moreAboutYou [name='fname']").val(),
          loyaltyFlag: $("#moreAboutYou [name='agreementSMPass']")
            .prop("checked")
            .toString(),
          phone: $("#moreAboutYou [name='telephone']").val(),
          postalCode: $("#moreAboutYou [name='pcode']").val().trim(),
        },
        dataType: "json",
        crossDomain: true,
        success: function (data) {
          if (data.Status == 1) {
            $("#addMoreButton").html("Submit").removeClass("spinning");
            $(".cls_popup").click();
          } else {
            $("#addMoreButton").html("Submit").removeClass("spinning");
            console.log("some problem occured please try again later.");
          }
        },
        error: function (e) {
          $("#addMoreButton").html("Submit").removeClass("spinning");
          console.log(e);
        },
      });
    };

    var checkUniquePhone = function () {
      $.ajax({
        url: baseURL + "Loyalty/CheckRegisterDetails",
        type: "POST",
        data: {
          phone: $("#moreAboutYou [name='telephone']").val(),
          zipCode: $("#moreAboutYou [name='pcode']").val(),
        },
        success: function (result) {
          if (result.Status == 1) {
            SubscribeNewsLetter();
          } else {
            $("#addMoreButton").html("Submit").removeClass("spinning");
            if (result.Message.indexOf("zip") > -1) {
              $("#moreAboutYou [name='pcode']").before(
                '<span class="dangerContent"> ' + result.Message + "</span>"
              );
            } else {
              $("#moreAboutYou [name='telephone']").before(
                "<span class='dangerContent'> Phone Number Already Exits </span>"
              );
            }
          }
        },
        error: function (result) {
          $("#addMoreButton").html("Submit").removeClass("spinning");
        },
      });
    };

    var ValidateData = function () {
      $(".dangerContent").remove();
      if ($("#moreAboutYou [name='email']").val().trim() == "") {
        $("#moreAboutYou [name='email']")
          .focus()
          .addClass("dangerFocus")
          .before("<span class='dangerContent'> required </span>");
        $("#addMoreButton").html("Submit").removeClass("spinning");
        return false;
      } else {
        $("#moreAboutYou [name='email']").removeClass("dangerFocus");
      }

      if ($("#moreAboutYou [name='fname']").val().trim() == "") {
        $("#moreAboutYou [name='fname']")
          .focus()
          .addClass("dangerFocus")
          .before("<span class='dangerContent'> required </span>");
        $("#addMoreButton").html("Submit").removeClass("spinning");
        return false;
      } else {
        $("#moreAboutYou [name='fname']").removeClass("dangerFocus");
      }

      if ($("#moreAboutYou [name='Lname']").val().trim() == "") {
        $("#moreAboutYou [name='Lname']")
          .focus()
          .addClass("dangerFocus")
          .before("<span class='dangerContent'> required </span>");
        $("#addMoreButton").html("Submit").removeClass("spinning");
        return false;
      } else {
        $("#moreAboutYou [name='Lname']").removeClass("dangerFocus");
      }

      if ($("#moreAboutYou [name='agreementSMPass']").prop("checked")) {
        if ($("#moreAboutYou [name='pcode']").val().trim() == "") {
          $("#moreAboutYou [name='pcode']")
            .focus()
            .addClass("dangerFocus")
            .before("<span class='dangerContent'> required </span>");
          $("#addMoreButton").html("Submit").removeClass("spinning");
          return false;
        } else {
          $("#moreAboutYou [name='pcode']").removeClass("dangerFocus");
        }

        if ($("#moreAboutYou [name='telephone']").val().trim() == "") {
          $("#moreAboutYou [name='telephone']")
            .focus()
            .addClass("dangerFocus")
            .before("<span class='dangerContent'> required </span>");
          $("#addMoreButton").html("Submit").removeClass("spinning");
          return false;
        } else {
          $("#moreAboutYou [name='telephone']").removeClass("dangerFocus");
        }
        checkUniquePhone();
      } else {
        SubscribeNewsLetter();
      }
    };

    $("#addMoreButton").click(function () {
      $(this).addClass("spinning").html("<div Class='loadingSpinner'></div>");
      ValidateData();
    });
  };

  if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
    loadScript("//code.jquery.com/jquery-2.2.4.min.js", function () {
      jQuery224 = jQuery.noConflict(true);
      newsLetterEvents(jQuery224);
    });
  } else {
    newsLetterEvents(jQuery);
  }
});

// Accessibility 06-02-23
$(document).keydown(function (e) {
  var key = e.which;
  if (key == 37 || key == 38 || key == 39 || key == 40) {
    e.preventDefault();
    return false;
  }
  return true;
});

if (
  typeof getCookie("oneturst-cookie") === "undefined" ||
  getCookie("oneturst-cookie") == "" ||
  getCookie("oneturst-cookie") != "Done"
) {
  $(".custom-onetrust-banner").slideDown(400);
}

if (getCookie("Gift") != "" && getCookie("Gift") == "No") {
  ManageCookie("Gift", "");
}
$("body").on("click", "#onetrust-accept-btn-handler", function (e) {
  e.preventDefault();
  ManageCookie("oneturst-cookie", "Done", 30);
  $(".custom-onetrust-banner").slideUp(400);
});

function desktop_navigation_access() {
  // First level Navigation
  $("body").on(
    "keyup",
    ".site-nav > li > span .toggle-button, .site-nav > li > span .site-nav__link",
    function (e) {
      var parent = $(this).parent(".posrel").next(".dropdownmenu");
      parent.find("li a").removeClass("insideUl");
      if (!$(e.target).hasClass("toggle-button")) {
        if ((e.keyCode === 9 && !e.shiftKey) || e.keyCode === 27) {
          hideMenu(currentToggleButton, currentDropdownContainer);

          if (e.keyCode === 27) {
            $(this).focus();
          }
        }
      }
      if (
        e.keyCode === 37 ||
        e.keyCode === 38 ||
        e.keyCode === 39 ||
        e.keyCode === 40
      ) {
        if (parent.length > 0) {
          // dropdown

          if (parent.find("li.col_menu_only").length > 0) {
            // first-type
            if (parent.find("li.col_menu_only:first span.posrel").length > 0) {
              if (
                !parent
                  .find("li.col_menu_only:first a.menu_only_title")
                  .hasClass("insideUl")
              ) {
                // $('a.menu_only_title').attr("tabindex","-1");
                // parent.find('li.col_menu_only a.menu_only_title').attr("tabindex","0");
                parent
                  .find("li.col_menu_only:first a.menu_only_title")
                  .focus()
                  .addClass("insideUl");
              }
            }
            // second-type
            else {
              if (
                !parent
                  .find("li.col_menu_only:first ul > li:first > a")
                  .hasClass("insideUl")
              ) {
                // $('a.menu_only_title').attr("tabindex","-1");
                // parent.find('li.col_menu_only ul > li:first > a.menu_only_title').attr("tabindex","0");
                parent
                  .find("li.col_menu_only:first ul > li:first > a")
                  .focus()
                  .addClass("insideUl");
              } else {
                parent
                  .find("li.col_menu_only:first ul > li > a.insideUl")
                  .parent("li")
                  .next("li > a")
                  .focus()
                  .addClass("insideUl");
              }
            }
          }
          // third-type
          else {
            if (
              !parent
                .find("li.col_menu_only:first ul > li:first > a")
                .hasClass("insideUl")
            ) {
              parent
                .find("li:not(.backTitle):first > a")
                .focus()
                .addClass("insideUl");
            }
          }
        }
      } else if (e.keyCode === 13) {
        if (parent.find("li.col_menu_only ul li > a")) {
          parent.find("li.col_menu_only ul li:first > a").trigger("click");
        }
      }
    }
  );

  // Dropdown navigation
  $("body").on(
    "keyup",
    "li.col_image_only img, li.col_image_only > a, .closecart",
    function (e) {
      if (
        e.keyCode === 37 ||
        e.keyCode === 38 ||
        e.keyCode === 39 ||
        e.keyCode === 40
      ) {
        if ($(this).parent().prev("li").find("a.menu_only_title").length > 0) {
          $(this)
            .parent()
            .prev("li")
            .find("a.menu_only_title")
            .focus()
            .addClass("insideUl");
        } else {
          $(this)
            .parent()
            .prev("li")
            .find("ul li:first-child > a")
            .focus()
            .addClass("insideUl");
        }
      }
      if (e.keyCode === 13) {
        $(this).trigger("click");
      }
    }
  );

  $("body").on(
    "keyup",
    ".dropdownmenu li:not(.backTitle) ul li:not(.backTitle3), .dropdownmenu li:not(.backTitle) a.menu_only_title, .defaultCol.dropdownmenu li:not(.backTitle)",
    function (e) {
      if ($(this).find(".posrel").length > 0 || $(this).hasClass("posrel")) {
        if (e.keyCode === 37 || e.keyCode === 38) {
          if (
            $(this).parents(".col_menu_only").prev("li.col_menu_only").length >
            0
          ) {
            if (
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("a.menu_only_title").length > 0
            ) {
              $(this)
                .parents(".col_menu_only")
                .find("a.menu_only_title")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("a.menu_only_title")
                .focus()
                .addClass("insideUl");
            } else {
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("ul li:first-child > a")
                .focus()
                .addClass("insideUl");
            }
          }
        }
        if (e.keyCode === 39) {
          if (
            $(this).parents(".col_menu_only").next("li.col_menu_only").length >
            0
          ) {
            if (
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("a.menu_only_title").length > 0
            ) {
              $(this)
                .parents(".col_menu_only")
                .find("a.menu_only_title")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("a.menu_only_title")
                .focus()
                .addClass("insideUl");
            } else {
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("ul li:first-child > a")
                .focus()
                .addClass("insideUl");
            }
          } else {
            // $(this).parents('.col_menu_only').next('li.col_image_only').find('img').attr('tabindex','-1').focus();
            $(this)
              .parents(".col_menu_only")
              .next("li.col_image_only")
              .find("img")
              .focus();
          }
        }
        if (e.keyCode === 40) {
          if (
            !$(this)
              .parent()
              .next("ul")
              .find("li:not(.backTitle3):first a")
              .hasClass("insideUl")
          ) {
            $(this)
              .parent()
              .next("ul")
              .find("li:not(.backTitle3):first > a")
              .focus()
              .addClass("insideUl");
          }
        }
      } else {
        // LEFT
        if (e.keyCode === 37) {
          if (
            $(this).parents(".col_menu_only").prev("li.col_menu_only").length >
            0
          ) {
            if (
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("span.posrel").length > 0
            ) {
              $(this)
                .parents(".col_menu_only")
                .find("a.menu_only_title")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("a.menu_only_title")
                .focus()
                .addClass("insideUl");
            } else {
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .prev("li.col_menu_only")
                .find("ul li:first-child > a")
                .focus()
                .addClass("insideUl");
            }
          }
        }
        // UP
        if (e.keyCode === 38) {
          if (
            $(this).find("a").hasClass("insideUl") &&
            !$(this).is(":first-child") &&
            !$(this).find("a").hasClass("menu_only_title") &&
            !$(this).prev("li").hasClass("backTitle_nav")
          ) {
            $(this)
              .prev("li:not(.backTitle_nav)")
              .find("a")
              .focus()
              .addClass("insideUl");
            $(this).find("a").removeClass("insideUl");
          } else {
            if (
              $(this).parents(".col_menu_only").find("span.posrel").length > 0
            ) {
              // $(this).parents('.col_menu_only').find('a.menu_only_title').removeClass('insideUl');
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .find("a.menu_only_title")
                .focus()
                .addClass("insideUl");
            } else {
              if (
                $(this).parents(".col_menu_only").prev("li.col_menu_only")
                  .length > 0
              ) {
                $(this)
                  .parents(".col_menu_only")
                  .find("a")
                  .removeClass("insideUl");
                $(this)
                  .parents(".col_menu_only")
                  .prev("li.col_menu_only")
                  .find("ul li:first-child > a")
                  .focus()
                  .addClass("insideUl");
              }
            }
          }
        }
        // RIGHT
        if (e.keyCode === 39) {
          if (
            $(this).parents(".col_menu_only").next("li.col_menu_only").length >
            0
          ) {
            if (
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("span.posrel").length > 0
            ) {
              $(this)
                .parents(".col_menu_only")
                .find("a.menu_only_title")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("a.menu_only_title")
                .focus()
                .addClass("insideUl");
            } else {
              $(this)
                .parents(".col_menu_only")
                .find("a")
                .removeClass("insideUl");
              $(this)
                .parents(".col_menu_only")
                .next("li.col_menu_only")
                .find("ul li:first-child > a")
                .focus()
                .addClass("insideUl");
            }
          } else {
            // $(this).parents('.col_menu_only').next('li.col_image_only').find('img').attr('tabindex','-1').focus();
            $(this)
              .parents(".col_menu_only")
              .next("li.col_image_only")
              .find("img")
              .focus();
          }
        }
        // DOWN
        if (e.keyCode === 40) {
          if (
            $(this).find("a").hasClass("insideUl") &&
            !$(this).is(":last-child")
          ) {
            $(this).next("li").find("a").focus().addClass("insideUl");
            $(this).find("a").removeClass("insideUl");
          } else {
            if (
              $(this).parents(".col_menu_only").next("li.col_menu_only")
                .length > 0
            ) {
              if (
                $(this)
                  .parents(".col_menu_only")
                  .next("li.col_menu_only")
                  .find("span.posrel").length > 0
              ) {
                $(this)
                  .parents(".col_menu_only")
                  .find("a.menu_only_title")
                  .removeClass("insideUl");
                $(this)
                  .parents(".col_menu_only")
                  .find("a")
                  .removeClass("insideUl");
                $(this)
                  .parents(".col_menu_only")
                  .next("li.col_menu_only")
                  .find("a.menu_only_title")
                  .focus()
                  .addClass("insideUl");
              } else {
                $(this)
                  .parents(".col_menu_only")
                  .find("a")
                  .removeClass("insideUl");
                $(this)
                  .parents(".col_menu_only")
                  .next("li.col_menu_only")
                  .find("ul li:first-child > a")
                  .focus()
                  .addClass("insideUl");
              }
            }
          }
        }
      }
      if (e.shiftKey && e.keyCode === 9) {
        // $('.dropdownmenu li a').attr("tabindex","-1");
        $(this)
          .closest("li.hasDropDown")
          .prev()
          .find("span.posrel > a")
          .focus();
      }
    }
  );

  $("body").on("mouseover", ".site-nav li.hasDropDown", function (e) {
    currentToggleButton = $(this).find(".toggle-button");
    currentDropdownContainer = $(this);
    showMenu(currentToggleButton, currentDropdownContainer);
  });

  $("body").on("mouseout", ".site-nav li.hasDropDown", function (e) {
    currentToggleButton = $(this).find(".toggle-button");
    currentDropdownContainer = $(this);
    hideMenu(currentToggleButton, currentDropdownContainer);
  });
}
// Accessibility 06-02-23

if (jQuery(window).width() <= 991) {
  jQuery("body").on("click", ".site-nav>li>span>.toggleItem", function (e) {
    e.preventDefault();
    $(".navbar")[0].scrollTop = 0;
    $(".navbar").addClass("mobfoxheight");
    $(this)
      .parents(".hasDropDown")
      .find(".dropdownmenu")
      .addClass("toggleSubMenu")
      .css({ transform: "translate(0)", "-webkit-transform": "translateX(0)" });
    $(this).closest("span.posrel").attr("aria-expanded", "true");
    $(".backTitle").removeClass("backTitle_nav_add");
    $(this)
      .parents(".hasDropDown")
      .find(".dropdownmenu")
      .find("li.backTitle_nav:first")
      .addClass("backTitle_nav_add");
  });

  jQuery("body").on("click", ".backTitle", function (e) {
    e.preventDefault();
    $(this)
      .parents(".hasDropDown")
      .find(".dropdownmenu")
      .removeClass("toggleSubMenu")
      .css({ transform: "unset", "-webkit-transform": "unset" });
    $(".navbar").removeClass("mobfoxheight");
    $(this)
      .closest("li.hasDropDown")
      .find("span.posrel")
      .attr("aria-expanded", "false");
    $(this)
      .parents(".hasDropDown")
      .find(".dropdownmenu")
      .find("li.backTitle_nav")
      .removeClass("backTitle_nav_add");
  });

  jQuery("body").on("click", ".level3", function (e) {
    e.preventDefault();
    $(this).parents(".col_menu_only").addClass("open_step3");
    $(this).closest("ul.dropdownmenu").addClass("open_childofchild");
    localStorage.setItem("secondScroll", jQuery(".toggleSubMenu").scrollTop());
    $(this).closest("ul.dropdownmenu")[0].scrollTop = 0;
    $(".backTitle").removeClass("backTitle_nav_add");
    $(this)
      .parents(".col_menu_only.open_step3")
      .find("li.backTitle3")
      .addClass("backTitle_nav_add");
  });

  jQuery("body").on("click", ".backTitle3", function (e) {
    e.preventDefault();
    $(this).parents(".col_menu_only").removeClass("open_step3");
    jQuery(this).closest("ul.dropdownmenu").removeClass("open_childofchild");
    jQuery(this).closest("ul.dropdownmenu")[0].scrollTop =
      localStorage.getItem("secondScroll");
    $(this).removeClass("backTitle_nav_add");
    $(this)
      .parents("li.col_menu_only")
      .closest("ul.dropdownmenu")
      .find("li.backTitle")
      .addClass("backTitle_nav_add");
  });

  // Accessibility 06-02-23
  // KEYBOARD ACCESSIBLE MOBILE START
  $("body").on(
    "keyup",
    ".navbar nav[data-main-menu]:visible .site-nav > li > span.posrel",
    function (e) {
      if (e.keyCode === 38 || e.keyCode === 37) {
        if ($(this).parent("li").prev("li").length > 0) {
          $(this).parent("li").prev("li").find("span").focus();
        } else {
          $(this)
            .parents("nav[data-main-menu]:visible .site-nav")
            .find(".mobmenutop")
            .find("a:last-child")
            .focus();
        }
      } else if (e.keyCode === 40 || e.keyCode === 39) {
        if ($(this).parent("li").next("li").length > 0) {
          $(this).parent("li").next("li").find("span").focus();
        } else {
          if ($(this).parent().is(":last-child")) {
            $(this)
              .parents(".mobile-Navbar")
              .find(".site-page-menu")
              .find("li:first-child a")
              .focus();
          }
        }
      } else if (e.keyCode === 13) {
        $(this).find(".toggleItem").trigger("click");
        setTimeout(function () {
          $("li.backTitle_nav_add:first a").focus();
        }, 200);
        $("li.hasDropDown")
          .closest("span.posrel")
          .attr("aria-expanded", "false");
        $(this).attr("aria-expanded", "true");
      } else if (e.keyCode === 27) {
        jQuery("body").removeClass("menuOpen");
        opend_pop.focus();
      }
    }
  );

  $("body").on(
    "keydown",
    "nav[data-main-menu]:visible .site-page-menu a",
    function (e) {
      if ($(this).is(":first-child")) {
        if (e.keyCode === 27 && !$(this).is(":focus")) {
          $(this)
            .parents(".navbar")
            .find("nav[data-main-menu]:visible ul > li:last-child > span")
            .focus();
        }
      }
    }
  );

  $("body").on(
    "keyup",
    "nav[data-main-menu]:visible .dropdownmenu li a, nav[data-main-menu]:visible .dropdownmenu li h2 a",
    function (e) {
      console.log($(this), "$(this)");
      if (e.keyCode === 38 || e.keyCode === 37) {
        if ($(this).closest("li").hasClass("backTitle_nav")) {
          if (
            $(this)
              .parents(".toggleSubMenu")
              .find("li.col_menu_only:last")
              .find("a.menu_only_title").length > 0 &&
            $(this).closest("li.backTitle_nav").hasClass("backTitle")
          ) {
            $(this)
              .parents(".toggleSubMenu")
              .find("li.col_menu_only:last")
              .find("a.menu_only_title")
              .focus();
          } else if (
            $(this).closest("li.backTitle_nav").hasClass("backTitle3")
          ) {
            $(this).parents(".menu_step3").find("li:last > a").focus();
          } else if (
            !$(this).closest("li.backTitle_nav").hasClass("backTitle3")
          ) {
            $(this).parents(".toggleSubMenu").find("li:last-child > a").focus();
          }
        } else {
          if (
            $(this)
              .closest('li[role="menuitem"]')
              .find("ul li:first-child a")
              .text() != $(this).text() &&
            !$(this).hasClass("menu_only_title")
          ) {
            $(this).closest("li").prev().find("a").focus();
          } else {
            if (
              $(this)
                .closest('li[role="menuitem"]')
                .prev()
                .find("a.menu_only_title").length > 0
            ) {
              $(this)
                .closest('li[role="menuitem"]')
                .prev()
                .find("a.menu_only_title")
                .focus();
            } else if (
              $(this)
                .closest('li[role="menuitem"]')
                .prev()
                .find("ul > li:last-child a").length > 0
            ) {
              $(this)
                .closest('li[role="menuitem"]')
                .prev()
                .find("ul > li:last-child a")
                .focus();
            } else if (
              $(this)
                .closest('li[role="menuitem"]')
                .prev()
                .hasClass("backTitle_nav")
            ) {
              $(this).closest('li[role="menuitem"]').prev().find("a").focus();
            }
          }
        }
      }
      if (e.keyCode === 40 || e.keyCode === 39) {
        if ($(this).closest("li").hasClass("backTitle_nav")) {
          if ($(this).closest(".toggleSubMenu").hasClass("defaultCol")) {
            $(this).closest("li.backTitle_nav").next().find("a").focus();
          } else if (
            $(this)
              .parents(".toggleSubMenu")
              .find("li.col_menu_only:first")
              .find("a.menu_only_title").length > 0 &&
            $(this).closest("li.backTitle_nav").hasClass("backTitle")
          ) {
            $(this)
              .parents(".toggleSubMenu")
              .find("li.col_menu_only:first")
              .find("a.menu_only_title")
              .focus();
          } else if (
            $(this).closest("li.backTitle_nav").hasClass("backTitle3")
          ) {
            $(this).parent().next().find("a").focus();
          } else {
            $(this).parent().next().find("li:first > a").focus();
          }
        } else {
          if (
            ($(this).hasClass("menu_only_title") &&
              $(this)
                .parents(".toggleSubMenu")
                .find("li.col_menu_only:last a.menu_only_title")
                .text() == $(this).text()) ||
            ($(this).closest(".toggleSubMenu").hasClass("defaultCol") &&
              $(this).parents(".toggleSubMenu").find("li:last a").text() ==
                $(this).text())
          ) {
            setTimeout(function () {
              $("li.backTitle_nav_add a").focus();
            }, 200);
          } else if (
            $(this)
              .closest('li[role="menuitem"]')
              .find("ul li:last-child a")
              .text() != $(this).text() &&
            !$(this).hasClass("menu_only_title")
          ) {
            $(this).closest("li").next().find("a").focus();
          } else {
            if (
              $(this)
                .closest('li[role="menuitem"]')
                .next()
                .find("a.menu_only_title").length > 0 &&
              $(this).closest(".menu_step3").length == 0
            ) {
              $(this)
                .closest('li[role="menuitem"]')
                .next()
                .find("a.menu_only_title")
                .focus();
            } else if ($(this).closest(".menu_step3").length > 0) {
              $(this)
                .closest(".menu_step3")
                .find("li.backTitle_nav  a")
                .focus();
            } else if (
              $(this)
                .closest('li[role="menuitem"]')
                .next()
                .hasClass("col_menu_only")
            ) {
              $(this)
                .closest('li[role="menuitem"]')
                .next()
                .find("ul > li:first-child a")
                .focus();
            } else {
              setTimeout(function () {
                $("li.backTitle_nav_add > a").focus();
              }, 200);
            }
          }
        }
      }
      if (e.keyCode === 13) {
        e.preventDefault();
        if ($(this).hasClass("menu_only_title")) {
          $(this).find(".toggleItem").trigger("click");
          setTimeout(function () {
            $("li.backTitle_nav_add:first a").focus();
          }, 200);
        } else if ($(this).closest("li.backTitle_nav").hasClass("backTitle3")) {
          $(this).closest("li.col_menu_only").find("a.menu_only_title").focus();
          $(this).closest("li.backTitle_nav").trigger("click");
        } else if ($(this).closest("li.backTitle_nav").hasClass("backTitle")) {
          $(this).closest("li.hasDropDown").find("a.site-nav__link").focus();
        }
      } else if (e.keyCode === 27) {
        jQuery("body").removeClass("menuOpen");
        opend_pop.focus();
      }
    }
  );

  // $('body').on('keydown',".site-page-menu a:first-child",function(e){
  //   if((e.keyCode === 9 && !e.shiftKey)) {
  //       $('.headerbar').find('.mobileNav').focus();
  //   }
  // });

  $("body").on(
    "keydown",
    "nav[data-main-menu]:visible .dropdownmenu li a",
    function (e) {
      if (e.keyCode === 9) {
        e.preventDefault();
        return false;
      }
    }
  );

  $(".site-nav li.hasDropDown > span.posrel").attr("tabindex", "0");
  $(".site-nav li.hasDropDown > span.posrel > a").attr("tabindex", "-1");
  $(".dropdownmenu li a").attr("tabindex", "0");
  // KEYBOARD ACCESSIBLE MOBILE END
  // Accessibility 06-02-23
}

jQuery("body").on("click", ".mobileNav", function (e) {
  e.preventDefault();
  opend_pop = $(this);
  jQuery("body").toggleClass("menuOpen");
  setTimeout(function () {
    $(".mobile-Navbar").focus();
  }, 500);
  if ($(".fixed_countdown").length) {
    jQuery(".navbar").css(
      "top",
      jQuery("#main-header").outerHeight() +
        jQuery(".countdown-banner").outerHeight() -
        3 +
        "px"
    );
    jQuery(".navbar").css(
      "height",
      "calc(100% - " +
        (jQuery("#main-header").outerHeight() +
          jQuery(".countdown-banner").outerHeight() -
          3) +
        "px)"
    );
  } else {
    jQuery(".navbar").css(
      "top",
      jQuery("#main-header").outerHeight() - 3 + "px"
    );
    jQuery(".navbar").css(
      "height",
      "calc(100% - " + (jQuery("#main-header").outerHeight() - 3) + "px)"
    );
  }
});

// Accessibility 06-02-23
$("body").on("keydown", ".radio-wrapper .radio-btn", function (e) {
  if (e.keyCode === 13) {
    $(this).find("input").trigger("click");
  }
});
$("body").on(
  "keydown",
  ".ais-facets .ais-facet--item>div input[type=checkbox]",
  function (e) {
    if (e.keyCode === 13) {
      $(this).trigger("click");
    }
  }
);
// KEYBOARD ACCESSIBLE DESKTOP START
if (jQuery(window).width() > 991) {
  desktop_navigation_access();
}

/**
  Menu visibility
*/
var navbar = document.querySelector(".site-nav"),
  menuVisible = false,
  currentToggleButton,
  currentDropdownContainer,
  alltogglebutton = $(".toggle-button");

function closeOtherSubmenus(currentToggleButton) {
  $.each(alltogglebutton, function (i, item) {
    const otherToggleButton = $(item);
    if (
      otherToggleButton.attr("aria-controls") !==
        currentToggleButton.attr("aria-controls") &&
      otherToggleButton.attr("aria-expanded") === "true"
    ) {
      hideMenu(otherToggleButton, otherToggleButton.closest("li.hasDropDown"));
    }
  });
}

function showMenu(currentToggleButton, currentDropdownContainer) {
  if (!currentToggleButton) return;

  closeOtherSubmenus(currentToggleButton);
  currentToggleButton.attr("aria-expanded", true);
  currentDropdownContainer.addClass("add_hover");
  menuVisible = true;
}

function hideMenu(currentToggleButton, currentDropdownContainer) {
  if (!currentToggleButton) return;

  currentToggleButton.attr("aria-expanded", false);
  currentDropdownContainer.removeClass("add_hover");
  menuVisible = false;
}

function toggleMenu() {
  if (menuVisible) {
    hideMenu(currentToggleButton, currentDropdownContainer);
  } else {
    showMenu(currentToggleButton, currentDropdownContainer);
  }
}

// Close the menu when the user activates something outside the navbar.
$(document).on("keyup click", function (e) {
  if ($(".site-nav").has($(e.target)).length == 0) {
    hideMenu(currentToggleButton, currentDropdownContainer);
  }
});

jQuery("body").on("click", ".toggle-button", function (e) {
  currentToggleButton = $(this);
  currentDropdownContainer = $(this).parents("li.hasDropDown");
  if (currentToggleButton.attr("aria-expanded") == "true") {
    hideMenu(currentToggleButton, currentDropdownContainer);
  } else {
    showMenu(currentToggleButton, currentDropdownContainer);
  }
  console.log(currentToggleButton.attr("aria-expanded"), "$56");
});

/**
  Menu visibility end
*/
// KEYBOARD ACCESSIBLE DESKTOP END
// Accessibility 06-02-23
jQuery(document).ready(function () {
  if (navigator.platform.toUpperCase().indexOf("MAC") >= 0) {
    jQuery("body").addClass("mac-os");
  }

  jQuery("body").on("click", ".cls_popup", function (e) {
    e.preventDefault();
    jQuery(".videoPop").fadeOut("slow");
  });

  $("body").on("click", ".banner-api-product > a", function (e) {
    e.preventDefault();
    productClickEvent($(this).attr("href"));
  });

  function upsellDatalayer() {
    if (
      typeof dataLayerUpsellProducts !== "undefined" &&
      dataLayerUpsellProducts != ""
    ) {
      window.dataLayer.push({
        event: "Cart Upsell Items Displayed",
        productList: {
          name: "Complete Your Order",
          products: dataLayerUpsellProducts,
        },
        _clear: true,
      });
    }
  }

  function cartCollectionSlider() {
    if ($(".cart-upsell-slider").length != 0) {
      $(".cart-upsell-slider").slick({
        infinite: false,
        arrows: true,
        dots: false,
        autoplay: false,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: $(".n-prev-arrow"),
        nextArrow: $(".n-next-arrow"),
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }
  }
  cartCollectionSlider();

  if (jQuery(".tab-content-1").length > 0) {
    //Default Action Product Tab
    jQuery(".tab-content-1").hide(); //Hide all content
    jQuery("ul.tabs-1 li:first").addClass("active").show(); //Activate first tab
    jQuery(".tab-content-1:first").show(); //Show first tab content
    //On Click Event Product Tab
    jQuery("ul.tabs-1 li").click(function () {
      jQuery("ul.tabs-1 li").removeClass("active"); //Remove any "active" class
      jQuery(this).addClass("active"); //Add "active" class to selected tab
      jQuery(".tab-content-1").hide(); //Hide all tab content
      var activeTab = jQuery(this).find("a").attr("href"); //Find the rel attribute value to identify the active tab + content
      jQuery(activeTab).fadeIn(); //Fade in the active content

      if (
        jQuery(activeTab).find(".productSlider").hasClass("slick-initialized")
      ) {
        jQuery(".productSlider").slick("refresh");
      }

      return false;
    });
  }

  $(".tablist2 ul li").click(function (e) {
    e.preventDefault();
    $(".tablist2 ul li").removeClass("activetab");
    $(".relatedProductC").hide();
    var currenTab = $(this).data("id");
    $(this).addClass("activetab");
    $("#" + currenTab).show();
    //var x = $(this).attr('data-slick');
    if ($(".responsive").hasClass("slick-initialized")) {
      $(".responsive").slick("refresh");
    }
  });

  if ($("body.used_condition_occur").length) {
    var all_sizes = [],
      all_condition = [];
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    $("body").on("change", ".rebooted_filter select", function () {
      var size_filter = $(
        '.rebooted_filter select[name="rebooted_size_filter"]'
      ).val();
      var condition_filter = $(
        '.rebooted_filter select[name="rebooted_condition_filter"]'
      ).val();
      if (size_filter == "all" && condition_filter == "all") {
        $(".rebooted_grid").show();
      } else {
        $(".rebooted_grid").hide();
        if (size_filter == "all" && condition_filter != "all") {
          $('.rebooted_grid[data-condition="' + condition_filter + '"]').show();
        } else if (size_filter != "all" && condition_filter == "all") {
          $('.rebooted_grid[data-size_name="' + size_filter + '"]').show();
        } else {
          $(
            '.rebooted_grid[data-size_name="' +
              size_filter +
              '"][data-condition="' +
              condition_filter +
              '"]'
          ).show();
        }
      }
    });

    $(".rebooted_filter .nice-select").each(function () {
      var select = $(this),
        name = select.attr("name");
      if (select.find("option").length) {
        select.hide();
        select.wrap('<div class="nice-select-wrap"></div>');
        var parent = select.parent(".nice-select-wrap");
        parent.append("<ul id=" + name + ' style="display:none"></ul>');
        select.find("option").each(function () {
          var option = $(this),
            value = option.attr("value");
          if (option.is(":selected")) {
            $(
              '<a href="#" class="drop"><span class=main_val>' +
                value +
                "</span></a>"
            ).insertBefore(parent.find("ul"));
          }
          parent
            .find("ul")
            .append(
              '<li><a href="#" id="' +
                value +
                '"><span class=main_val>' +
                value +
                "</span></a></li>"
            );
        });
      }
    });
    $("body").on("click", ".rebooted_filter .drop", function (e) {
      $(this).closest(".nice-select-wrap").toggleClass("down");
      $(this).closest(".nice-select-wrap").find("ul").slideToggle(300);
      $(".is_main_body").addClass("rebooted_open_filter");
      e.preventDefault();
    });
    $(".is_main_body").on("click", ".rebooted_filter_overly", function (e) {
      $(".rebooted_filter .nice-select-wrap").removeClass("down");
      $(".rebooted_filter .nice-select-wrap ul").slideUp(300);
      $(".is_main_body").removeClass("rebooted_open_filter");
      e.preventDefault();
    });
    $("body").on("click", ".rebooted_filter ul a", function (e) {
      var niceOption = $(this),
        value = niceOption.attr("id"),
        text = niceOption.html();
      $(this)
        .closest(".nice-select-wrap")
        .find("select")
        .val(value)
        .trigger("change");
      $(this).closest(".nice-select-wrap").find(".drop").html(text);
      $(this).closest(".nice-select-wrap").toggleClass("down");
      $(this).closest(".nice-select-wrap ul").slideUp(300);
      $("body").removeClass("rebooted_open_filter");
      e.preventDefault();
    });
  }

  if (new URLSearchParams(window.location.search).get("app") === "kinn") {
    $("div.topbar-rolling-text:has(p.hide-in-app) > p.hide-in-app").remove();
    $("div.hide_on_app").remove();
    $(".app_hide").remove();
    $(".app_only").parent().show();
  } else {
    $(".app_only").parent().remove();
  }

  $("body").on("click", ".closeZoom", function () {
    closeZoom();
  });

  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });

  var closeZoom = function () {
    $(".zoomImgsWrap").remove();
    opend_pop.focus();
    $("body").removeClass("ovfHidden");
    $(".mainImg").removeClass("current");
  };

  function checkWP() {
    if ($("#generic_gallery_settings").length) {
      var wp = JSON.parse(
        document.getElementById("generic_gallery_settings").innerHTML
      );
      if (wp.total_number_of_images < 3) {
        $(".yotpo-pictures-widget").hide();
      }
    } else {
      setTimeout(function () {
        checkWP();
      }, 500);
    }
  }
  checkWP();

  $("body").on("click", "#submitorder", function (event) {
    if (
      $("#ordernum").val() != "" &&
      $("#billemail").val() != "" &&
      $("#billzip").val() != ""
    ) {
      $("#overlay").show();
      event.preventDefault();
      var serializedData = $("#ordertrackingform").serialize();

      $.ajax({
        url: "https://services1.stevemadden.com/Responsys/TrackOrder",
        type: "POST",
        data: serializedData,
        crossDomain: true,
        success: function (data) {
          $("#overlay").hide();
          if (data == "invalid") {
            $("#msg").html("Email or Zipcode dosn't match with order Number.");
          } else if (data.Status == 0) {
            $("#msg").addClass("errmsg");
            $("#msg").html(data.Message);
          } else {
            $("#msg").html(" ");
            $("#ordertrackingcontent").html(data.Data);
            //$("#ordertrackingcontent").html(data);
          }
        },
        error: function (data) {
          $("#overlay").hide();
          $("#msg").html("Plz try later.");
        },
      });
    }
  });

  $(".CPcolorVar:not(.done)").each(function () {
    var a = $(this);
    var u = a.attr("href");
    $.getJSON(u, function (p) {}).fail(function () {
      a.remove();
    });
    $(this).addClass("done");
  });

  $("body").on("click", ".select-title", function () {
    console.log("innnnn");
    var val = $(this).attr("data-id");
    $(".scrollbar-inner." + val).toggleClass("active");
  });

  $("body").on("click", ".tab-title", function () {
    $(".tab-title").removeClass("active-tab");
    $(".tab-content").removeClass("active-tab");
    var val = $(this).attr("data-id");
    $(this).addClass("active-tab");
    $(".tab-content." + val).addClass("active-tab");
  });

  if (window.innerWidth < 768) {
    $(".tab-content-wrapper").slick({
      dots: false,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 581,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  $(document).ajaxStop(function () {
    $(".availColor").each(function () {
      var s = $(this).find(".CPcolorVar").length - 1;
      if (s > 0)
        $(this)
          .find(".moreColor")
          .text("+ " + s + " more");
    });
  });

  $(".colorVar").each(function () {
    var a = $(this);
    var u = a.attr("href");
    $.getJSON(u, function (p) {
      a.addClass("show");
    }).fail(function () {
      a.hide();
    });
  });

  $(".qtyAdjustBox a").on("click", function (e) {
    e.preventDefault();
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    if ($(this).hasClass("plus")) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip == 0) {
      return false;
    }
    input.val(ip);
  });

  // Zoom Image PDP
  var scaleMultiplier = 1.0,
    panStepSize = 25,
    imgwidth = 0,
    wrapperwidth = 0,
    imgTop = 0,
    imagetopTotal = 0;
  var pt = window.sm_theme.variable.product_title;
  $(".proImgClrGroup .featuredSlide").on("click", function () {
    $(".proImgClrGroup .featuredSlide .zoom_object").removeClass("current");
    // $('.proImgClrGroup .featuredSlide').removeClass('first-focusable-element');
    $(this).find(".zoom_object").addClass("current");
    // $(this).addClass('first-focusable-element');
    $("body").addClass("ovfHidden");
    $("body").append(
      '<div class="zoomImgsWrap" role="dialog" aria-modal="true" aria-label="image zoom popup" tabindex="-1"><div class="zoomimage_wrapper" role="region" aria-label="image with zoom and pan functionality"><p class="sr-only">Use the following zoom and pan buttons to control the image that follows them. You can either scroll using keyboard arrows.</p><div class="zoomImgsCont"></div> <button class="closeZoom" aria-label="close zoom">X</button><div class="controls" role="group" aria-label="controls"><div class="pan-controls"><button class="pan-up-button" title="Pan up"><span class="fa fa-angle-up" aria-hidden="true"></span><span class="sr-only">Pan up</span></button><div class="pan-controls-row"><button class="pan-left-button" title="Pan left"><span class="fa fa-angle-left" aria-hidden="true"></span><span class="sr-only">Pan left</span></button><button class="pan-right-button" title="Pan right"><span class="fa fa-angle-right" aria-hidden="true"></span><span class="sr-only">Pan right</span></button></div><button class="pan-down-button" title="Pan down"><span class="fa fa-angle-down" aria-hidden="true"></span><span class="sr-only">Pan down</span></button></div><div class="zoom-controls"><button class="zoom-in-button" title="Zoom in"><span class="fa fa-plus" aria-hidden="true"></span><span class="sr-only">Zoom in</span></button><button class="zoom-out-button" title="Zoom out"><span class="fa fa-minus" aria-hidden="true"></span><span class="sr-only">Zoom out</span></button></div></div></div></div>'
    );

    $(this)
      .closest(".proImgClrGroup")
      .find(".product-image:not(.slick-cloned) .zoom_object")
      .each(function (index, val) {
        if ($(this).hasClass("type_image")) {
          if ($(this).hasClass("current"))
            $(".zoomImgsCont").append(
              '<img class="zoomTo zoom_element active-image" tabindex="1" src="' +
                $(this).attr("data-img") +
                '" alt="' +
                pt +
                " of " +
                index +
                ' Zoom Image" />'
            );
          else
            $(".zoomImgsCont").append(
              '<img class="zoom_element" src="' +
                $(this).attr("data-img") +
                '" alt="' +
                pt +
                " of " +
                index +
                ' Zoom Image"/>'
            );
        } else if ($(this).hasClass("type_video")) {
          if ($(this).hasClass("current"))
            $(".zoomImgsCont").append(
              '<video class="zoomTo zoom_element" tabindex="1" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="' +
                $(this).parent().attr("data-img") +
                '"><source src="' +
                $(this).find("source").attr("src") +
                '" type="video/mp4"></video>'
            );
          else
            $(".zoomImgsCont").append(
              '<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="' +
                $(this).parent().attr("data-img") +
                '"><source src="' +
                $(this).find("source").attr("src") +
                '" type="video/mp4"></video>'
            );
        }
      });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs
      .load(function () {
        count--;
        if (!count) {
          //setTimeout(function(){
          var s = $(".zoomImgsCont .zoomTo").position().top;
          $(".zoomImgsCont").animate({ scrollTop: s }, 1000);
          //},500);
        }
      })
      .filter(function () {
        return this.complete;
      })
      .load();
    opend_pop = $(this);
    $(".zoomImgsWrap").focus();

    wrapperwidth =
      $(".zoomimage_wrapper").offset().left +
      $(".zoomimage_wrapper").outerWidth();
    imgwidth = $("img.zoomTo").offset().left + $("img.zoomTo").outerWidth();
    imgTop = $(".zoomimage_wrapper").offset().top;
    imagetopTotal =
      $(".zoomimage_wrapper").offset().top +
      $(".zoomimage_wrapper").outerHeight();
  });

  // On scroll change active image
  document.addEventListener(
    "scroll",
    function (event) {
      var windscroll = $(window).scrollTop();
      if (event.target.className === "zoomImgsCont") {
        // apply any filtering condition
        $(".zoom_element").each(function (i) {
          if ($(this).position().top <= windscroll - 0) {
            $(".zoom_element.active-image").removeClass("active-image");
            $(".zoom_element").eq(i).addClass("active-image");
          }
        });
      }
    },
    true
  );

  /********** Zooming ***********/
  // In
  $("body").on("click", ".zoom-in-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    scaleMultiplier += 0.1;
    if (scaleMultiplier >= 1) {
      image.css("transform", "scale(" + scaleMultiplier + ")");
    }
  });

  // Out
  $("body").on("click", ".zoom-out-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    scaleMultiplier -= 0.1;
    image.css("margin-left", "0px").css("margin-top", "0px");
    if (scaleMultiplier >= 1) {
      image.css("transform", "scale(" + scaleMultiplier + ")");
    }
  });

  $("body").on("keyup", ".zoomImgsWrap", function (e) {
    var getCurrentActiveImage = $(this).find(".zoom_element.active-image"),
      topPos;
    if (e.keyCode === 38 || e.keyCode === 37) {
      if (
        !getCurrentActiveImage.is(":first-child") &&
        getCurrentActiveImage.prev(".zoom_element").length > 0
      ) {
        const prevImage = getCurrentActiveImage.prev(".zoom_element");
        console.log(prevImage, "prevImage");
        $(".zoom_element").removeClass("active-image");
        getCurrentActiveImage.prev(".zoom_element").addClass("active-image");
        topPos =
          getCurrentActiveImage.prev(".zoom_element").offset().top +
          getCurrentActiveImage.prev(".zoom_element").parent().scrollTop() -
          getCurrentActiveImage.prev(".zoom_element").offsetParent().offset()
            .top;
      }
    } else if (e.keyCode === 40 || e.keyCode === 39) {
      if (
        !getCurrentActiveImage.is(":last-child") &&
        getCurrentActiveImage.next(".zoom_element").length > 0
      ) {
        const nextImage = getCurrentActiveImage.next(".zoom_element");
        console.log(nextImage, "nextImage");
        $(".zoom_element").removeClass("active-image");
        getCurrentActiveImage.next(".zoom_element").addClass("active-image");
        topPos =
          getCurrentActiveImage.next(".zoom_element").offset().top +
          getCurrentActiveImage.next(".zoom_element").parent().scrollTop() -
          getCurrentActiveImage.next(".zoom_element").offsetParent().offset()
            .top;
      }
    }
    $(".zoomImgsCont").animate(
      {
        scrollTop: topPos,
      },
      200
    );
  });

  /********** Panning ***********/
  // Up
  $("body").on("click", ".pan-up-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    var newimgTop = $("img.zoomTo").offset().top;

    if (newimgTop < imgTop) {
      var pos = parseInt(image.css("margin-top") || 0) + panStepSize + "px";
      image.css("margin-top", pos);
    }
  });

  // Down
  $("body").on("click", ".pan-down-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    var wrapper = $(".zoomimage_wrapper");
    var newWidth = parseInt(
      (image.outerHeight() * scaleMultiplier - wrapper.outerHeight()) / 2
    );
    if (
      parseInt(image.css("margin-top") || 0) >
      -parseInt(
        image.outerHeight() * scaleMultiplier - wrapper.outerHeight() - newWidth
      )
    ) {
      var pos = parseInt(image.css("margin-top") || 0) - panStepSize + "px";
      image.css("margin-top", pos);
    }
  });

  // Left
  $("body").on("click", ".pan-left-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    var wrapper = $(".zoomimage_wrapper");
    if (
      parseInt(image.css("margin-left") || 0) < wrapper.outerWidth() &&
      wrapper.offset().left > image.offset().left
    ) {
      var pos =
        parseInt(image.css("margin-left") || 0) + panStepSize - 15 + "px";
      image.css("margin-left", pos);
    }
  });

  // Right
  $("body").on("click", ".pan-right-button", function () {
    var image = $(this).parents(".zoomImgsWrap").find("img.active-image");
    var wrapper = $(".zoomimage_wrapper");
    var newWidth = parseInt(
      (image.outerWidth() * scaleMultiplier - wrapper.outerWidth()) / 2
    );

    if (
      parseInt(image.css("margin-left") || 0) >
      -parseInt(
        image.outerWidth() * scaleMultiplier - wrapper.outerWidth() - newWidth
      )
    ) {
      var pos =
        parseInt(image.css("margin-left") || 0) - panStepSize + 15 + "px";
      image.css("margin-left", pos);
    }
  });
  // Zoom Image PDP

  if ($(".bundle_product_page").length == 0) {
    if ($("body.is_kid_shoes").length == 0) {
      $(".select_size")
        .find(".swatch-element")
        .sort(function (a, b) {
          return +a.dataset.size - +b.dataset.size;
        })
        .appendTo(".select_size .swatch_elements_wrapper fieldset");
    } else {
      $(".select_size")
        .find(".swatch-element.swatch-size")
        .sort(function (a, b) {
          return +a.dataset.size - +b.dataset.size;
        })
        .appendTo(".select_size .swatch_elements_wrapper fieldset ");
      $(".select_size")
        .find(".swatch-element:not(.swatch-size)")
        .sort(function (a, b) {
          return +a.dataset.size - +b.dataset.size;
        })
        .appendTo(".select_size .swatch_elements_wrapper fieldset");
    }
  }

  if ($(".bundle_product_page").length != 0) {
    $(".product-card").each(function (i, ele) {
      $(ele)
        .find(".select_size")
        .find(".swatch-element")
        .sort(function (a, b) {
          return +a.dataset.size - +b.dataset.size;
        })
        .appendTo(
          $(ele).find(".select_size .swatch_elements_wrapper fieldset")
        );
    });
  }

  if (
    $(".activeLink").length &&
    $(".activeLink").closest(".hasDropDown").children(".site-nav__link").length
  ) {
    var a = $(".activeLink")
      .last()
      .closest(".hasDropDown")
      .children(".site-nav__link")
      .attr("href");
    var at = $(".activeLink")
      .last()
      .closest(".hasDropDown")
      .children(".site-nav__link")
      .text();
    var ba =
      '<span><a href="' +
      a +
      '">' +
      at +
      '</a></span> <span class="arrow-space"> / </span>';
    $(".breadcrumb").prepend(ba);
  }

  if ($(".customer_login_btn").length) {
    $(".customer_login_btn").on("click", function () {
      var x = true;
      $(this).closest("form").find(".err-msg").remove();
      $(this).closest("form").find("input").removeClass("inputerror");
      var fn = $(this).closest("form").find("#customer_password");
      var em = $(this).closest("form").find("#customer_email");

      if (fn.val() == "") {
        fn.addClass("inputerror");
        fn.parent().append('<p class="err-msg">Please enter password.</p>');
        x = false;
      } else {
        fn.removeClass("inputerror");
        fn.parent().find(".err-msg").remove();
      }

      var regex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (em.val() == "" || !regex.test(em.val())) {
        em.addClass("inputerror");
        em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
        x = false;
      } else {
        em.removeClass("inputerror");
        em.parent().find(".err-msg").remove();
      }

      if (x == false) {
        return false;
      }

      $(this).closest("form").submit();
    });
  }

  if ($(".recover-password").length) {
    $(".recover-password").on("click", function () {
      var x = true;
      $(this).closest("form").find("input").removeClass("inputerror");
      $(this).closest("form").find(".err-msg").remove();
      var em = $(this).closest("form").find("#recover-email");
      var regex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (em.val() == "" || !regex.test(em.val())) {
        em.addClass("inputerror");
        em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
        x = false;
      } else {
        em.removeClass("inputerror");
        em.parent().find(".err-msg").remove();
      }

      if (x == false) {
        return false;
      }

      $(this).closest("form").submit();
    });
  }

  /*one page scroll pdp start here*/
  $(".thumbSlide").on("click", function () {
    if ($(window).width() > 991) {
      $(".thumbSlide").removeClass("activeThumb").attr("aria-current", "false");
      $(this).addClass("activeThumb").attr("aria-current", "true");
      var x = $(this).attr("data-index");
      var of = $('.featuredSlide[data-index="' + x + '"]').offset().top;
      $("html,body").animate({ scrollTop: of }, 300);
    }
  });

  $(window).on("mousewheel", function () {
    var scrollPos = $(window).scrollTop();
    $(".thumbSlide").each(function () {
      var currLink = $(this);
      var refElementIndex = currLink.attr("data-index");
      var refElement = $(
        '.featuredSlide[data-index="' + refElementIndex + '"]'
      );
      if (
        refElement.position().top - 100 <= scrollPos &&
        refElement.position().top + refElement.height() > scrollPos
      ) {
        $(".thumbSlide")
          .removeClass("activeThumb")
          .attr("aria-current", "false");
        currLink.addClass("activeThumb").attr("aria-current", "true");
      }
    });
  });
  /*one page scroll pdp end here*/
  /*pdp slick slider js start here*/
  $window = $(window);
  $slick_slider = $(".proImgClrGroup");
  settings = {
    centerMode: false,
    arrows: false,
    dots: true,
    autoplay: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
    accessibility: false,
  };
  /* -------- quick-view -------- */
  $("body").on(
    "afterChange swipe",
    ".quick-view-images",
    function (event, slick, currentSlide, nextSlide) {
      addDotsAttr();
    }
  );

  $("body").on("click", ".quick_add_btn, .color_element input", function (e) {
    e.preventDefault();
    var product_handle = $(this).attr("data-href");
    if (product_handle) getProductData(product_handle, e);
  });

  $("body").on("click", ".product_quickview .quick-btn-wide", function (e) {
    e.preventDefault();
    var product_handle = $(this).attr("href");
    getProductData(product_handle, e);
  });

  document.body.addEventListener("click", (event) => {
    // Check if the clicked element matches any of our selectors
    if (
      event.target.matches(".close-quick") ||
      event.target.matches(".overlay") ||
      event.target.matches(".btn.addtocart.quickAdd")
    ) {
      // Find the closest parent element with class ".product_quickview"
      const productQuickviewEl = event.target.closest(".product_quickview");
      let getProductData = null;

      // If found, locate the embedded JSON within it
      if (productQuickviewEl) {
        const quickJsonEl = productQuickviewEl.querySelector(
          '[type="application/json"].quick'
        );
        if (quickJsonEl) {
          getProductData = JSON.parse(quickJsonEl.textContent);
        }
      }

      // Remove the "active" class from .product_quickview and .overlay
      document
        .querySelectorAll(".product_quickview, .overlay")
        .forEach((el) => {
          el.classList.remove("active");
        });

      // Remove the "Fixed" class from <body>
      document.body.classList.remove("Fixed");

      // Focus on opend_pop after a short delay (assuming opend_pop is defined elsewhere)
      setTimeout(() => {
        if (typeof opend_pop !== "undefined" && opend_pop) {
          opend_pop.focus();
        }
      }, 100);

      // Push data to dataLayer for analytics
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "quick_view_close",
        quickviewProduct: getProductData,
        _clear: true,
      });
    }
  });

  if ($window.width() <= 991) {
    $slick_slider.slick(settings);
  }
  $window.on("resize load", function () {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass("slick-initialized")) {
        $slick_slider.slick("unslick");
      }
    } else if (!$slick_slider.hasClass("slick-initialized")) {
      return $slick_slider.slick(settings);
    }
  });
  // BUNDLE IMAGE SLICK START
  if ($(".bundle_card_wraper").length > 0) {
    $(".bundle_card_wraper .product-img-wp").slick(settings);
  }
  // BUNDLE IMAGE SLICK END
  /*pdp slick slider js end here*/

  var rmf = window.sm_theme.variable.money_format;
  // Execute on load

  /*faq js start here*/
  $("body").on("click", ".set > h3", function (event) {
    event.stopPropagation();
    event.preventDefault();
    if (event.target !== this && !$(event.target).closest("button").length) {
      return;
    }

    if ($(this).closest(".sm-faq-section").length == 0) {
      $(this).toggleClass("active");
      if ($(this).hasClass("active")) {
        $(this).find("button").attr("aria-expanded", "true");
      } else {
        $(this).find("button").attr("aria-expanded", "false");
      }
      var content = $(this).closest(".set").find(".textTabbing").is(":visible");
      $(this).siblings(".content").slideToggle(200);
      if ($(".productWrapper").length > 0) {
        var $panel_top = $(this).closest(".set");
        if (!content) {
          setTimeout(function () {
            $("html,body").animate(
              {
                scrollTop: $panel_top.offset().top,
              },
              0
            );
          }, 250);
        }
      }
    } else {
      if ($(this).hasClass("active")) {
        $(this).find("button").attr("aria-expanded", "false");
        $(this).removeClass("active");
        $(this).siblings(".content").slideUp(200);
        $(".set > h3 i").removeClass("down").addClass("up");
      } else {
        $(".set > h3 i").removeClass("down").addClass("up");
        $(this).find("i").removeClass("up").addClass("down");
        $(".set > h3").find("button").attr("aria-expanded", "false");
        $(".set > h3").removeClass("active");
        $(this).find("button").attr("aria-expanded", "true");
        $(this).addClass("active");
        $(".content").slideUp(200);
        $(this).siblings(".content").slideDown(200);
      }
    }
    if ($(".sticky_column2").hasClass("is_stuck")) {
      setTimeout(function () {
        $(document.body).trigger("sticky_kit:recalc");
      }, 350);
    }
  });

  // Accessibility 06-02-23
  /*faq js end here*/
  /*tab js start here*/
  function toggleTabs(_this) {
    var tab_id = _this.attr("data-tab");

    _this
      .parents(".trending-block")
      .find("ul.tabs li")
      .removeClass("activetab");
    _this
      .parents(".trending-block")
      .find(".tab-content")
      .removeClass("activetab");

    _this
      .parents(".trending-block")
      .find("ul.tabs li")
      .attr({ "aria-selected": "false", tabindex: "-1" });
    _this
      .parents(".trending-block")
      .find("ul.tabs li a")
      .attr("tabindex", "-1");
    _this.attr({ "aria-selected": "true", tabindex: "0" });

    _this.addClass("activetab");
    if ($("#" + tab_id).hasClass("slick-initialized")) {
      $("#" + tab_id).slick("refresh");
    }
    $("#" + tab_id).addClass("activetab");
  }

  $("body").on("click", "ul.tabs li", function () {
    toggleTabs($(this));
  });

  // key press on tabs - SV
  $("body").on("keydown", '.tabs[role="tablist"] li', function (e) {
    if ((e.keyCode === 9 && !e.shiftKey) || e.keyCode === 27) {
      var tab_id = $(this).attr("data-tab");
      $("#" + tab_id).focus();
    }
    if (e.keyCode === 37 || e.keyCode === 40) {
      if ($(this).prev("li").length > 0) {
        $(this).prev().focus().trigger("click");
      } else {
        $('.tabs[role="tablist"] li:last-child').focus().trigger("click");
      }
    }
    if (e.keyCode === 38 || e.keyCode === 39) {
      if ($(this).next("li").length > 0) {
        $(this).next().focus().trigger("click");
      } else {
        $('.tabs[role="tablist"] li:first-child').focus().trigger("click");
      }
    }
    if (e.key == "Home") {
      e.preventDefault();
      $('.tabs[role="tablist"] li:first-child').focus().trigger("click");
      return false;
    }
    if (e.key == "End") {
      e.preventDefault();
      $('.tabs[role="tablist"] li:last-child').focus().trigger("click");
      return false;
    }
    return true;
  });
  /*tab js end here*/
  // Accessibility 06-02-23

  $(".topbar-rolling-text").slick({
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });

  $(".sq_insta_wp").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if (window.sm_theme.variable.not_customer == true) {
    $('a[href="/account/register"]').attr("href", "/account/");
  }

  $(".cm_faq_title").click(function () {
    $(".cm_faq_title").removeClass("active");
    $(".faq_item_content").slideUp();
    $(".cm_faq_title").find("button").attr("aria-expanded", "false");
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
      $(this).find("button").attr("aria-expanded", "true");
    }
  });

  $("button[name='btnCancelOrder']").on("click", function () {
    // This prevents the form from submitting
    event.preventDefault();

    var ordernumber = $(this).data("order-id");
    if (ordernumber) {
      var param = {
        oid: ordernumber,
        action: "Cancel",
      };
      $.ajax({
        url: baseURL + "/Responsys/OrderRequest",
        type: "POST",
        data: param,
        success: function (data) {
          window.location.reload();
        },
      });
    }
  });

  if ($(window).width() <= 992) {
    $('.SearchForm [type="submit"]')
      .off("click touchend")
      .on("click touchend", function (event) {
        event.preventDefault();

        const SEARCH_ICON_URL =
          `//stevemadden.gr/cdn/shop/files/search_black_small.png?v=7087`.toString();

        const $body = $("body");
        const $form = $(this).parent();
        const $closeButton = $(
          '<button class="close-search" type="button" value="Close Search"><i class="fa fa-close" aria-hidden="true"></i><span class="sr-only">Close Search</span></button>'
        );
        const $searchIcon = $(
          `<img src="${SEARCH_ICON_URL}" alt="Search Icon" width="30" />`
        );

        $body.toggleClass("opened-search");
        $body.toggleClass("Fixed");
        $form.toggleClass("closed-search");

        $searchIcon.css("cursor", "pointer");
        $searchIcon
          .off("click touchend")
          .on("click touchend", function (event) {
            const value = $(".ui-autocomplete-input").val();

            if (value) $(".SearchForm form").submit();
          });

        if ($(".close-search").length == 0) $searchIcon.appendTo($form);

        $closeButton
          .off("click touchend")
          .on("click touchend", function (event) {
            $(".ui-autocomplete").hide();
            $(this).hide();
            $body.toggleClass("opened-search");
            $body.toggleClass("Fixed");
            $form.toggleClass("closed-search");
          });
        $closeButton.appendTo($body);

        return false;
      });
    $(document).on("keypress", function (event) {
      const key = event.key;
      const search = $(".SearchForm form input");

      if (search.is(":focus") && key == "Enter") {
        let value = search.val();

        if (value) $(".SearchForm form").submit();

        event.preventDefault();

        return false;
      }
    });
  }

  var smpasspluscart = getCookie("smpasspluscart");
  if (smpasspluscart == "true") {
    jQuery("#checkout_buyer_accepts_SMPASSPlus_footer").prop("checked", true);
    jQuery("#checkout_buyer_accepts_SMPASSPlus_footer").val("1");
  }

  var addLoyaltyPlusCardRemove = function (variantId, qty, prop) {
    jQuery.post("/cart/change.js", {
      quantity: qty,
      id: variantId,
    });
  };

  // add Loyalty plus card
  var addLoyaltyPlusCard = function (variantId, qty, prop) {
    jQuery.post("/cart/add.js", {
      quantity: qty,
      id: variantId,
      properties: {
        UPC: "Membership",
      },
    });
  };

  $(".closeFl").on("click", function (e) {
    e.preventDefault();
    $(".smFloater").hide();
    $.cookie("pa-floater-count", 0, { expires: 1 });
    var cnt_close = Number(getCookie("cnt_close"));
    cnt_close++;
    ManageCookie("cnt_close", cnt_close, 365);
  });
  $(".app_added").on("click", function (e) {
    e.preventDefault();
    var app_added = Number(getCookie("app_added"));
    app_added++;
    ManageCookie("app_added", app_added, 365);
    window.location = $(this).attr("href");
  });
  var customer_visit = Number(getCookie("sm_cust_visit"));
  customer_visit++;
  ManageCookie("sm_cust_visit", customer_visit, 365);

  var close_cnt = Number(getCookie("cnt_close"));
  var app_added_cnt = Number(getCookie("app_added"));
  if (customer_visit > 1 && close_cnt < 2 && app_added_cnt == 0) {
    jQuery.get("/browsing_context_suggestions.json", (d) => {
      if (d.detected_values.country.handle === "US") {
        var width = $(window).width();
        if (width < 828) {
          var attCooie = Number(getCookie("__attentive_pv"));
          var userAgent =
            navigator.userAgent || navigator.vendor || window.opera;
          if (/iPad|iPhone|iPod/.test(userAgent)) {
            var s = getCookie("sp");
            $(".smFloater").show();
            $("#pa_ios_button").attr("style", "display: block !important");
          }
          if (/android/i.test(userAgent)) {
            var s = getCookie("sp");
            $(".smFloater").show();
            $("#pa_android_button").attr("style", "display: block !important");
          }
        }
      } else {
        $(".smFloater").hide();
      }
    });
  } else {
    $(".smFloater").hide();
  }

  $(
    "input[type=checkbox][name=checkout_buyer_accepts_SMPASSPlus_footer]"
  ).change(function () {
    if ($("#checkout_buyer_accepts_SMPASSPlus_footer").val() == "1") {
      $("#checkout_buyer_accepts_SMPASSPlus_footer").prop("checked", false);
      $("#checkout_buyer_accepts_SMPASSPlus_footer").val("0");
      addLoyaltyPlusCardRemove("31175889813594", 0, "");
      setTimeout(function () {
        ManageCookie("smpasspluscart", null, -1);
      }, 1000);
    } else if ($("#checkout_buyer_accepts_SMPASSPlus_footer").val() == "0") {
      $("#checkout_buyer_accepts_SMPASSPlus_footer").prop("checked", true);
      $("#checkout_buyer_accepts_SMPASSPlus_footer").val("1");
      var smpasspluscart = getCookie("smpasspluscart");
      if (smpasspluscart != "true") {
        addLoyaltyPlusCard("31175889813594", 1, { UPC: "Membership" });
        $(".step__footer__continue-btn").attr("disabled", "disabled");
        setTimeout(function () {
          ManageCookie("smpasspluscart", true, 7);
        }, 1000);
      }
    }
  });

  $("#agreementSMPass").click(function () {
    if ($(this).is(":checked")) {
      $('input[name="telephone"]').prop("required", true);
      $('input[name="pcode"]').prop("required", true);
    } else {
      $('input[name="telephone"]').prop("required", false);
      $('input[name="pcode"]').prop("required", false);
    }
  });

  $("#shopify-section-footer a").each(function (i, e) {
    if ($(this).html().toUpperCase() == "CA TRANSPARENCY ACT") {
      $(this).attr({
        rel: "noopener",
        target: "_blank",
      });
    }
  });

  jQuery(".filterToggle").on("click", function (e) {
    e.preventDefault();
    setTimeout(function () {
      jQuery("body").addClass("filterOpen");
      jQuery(".fullPage").addClass("witmenu");
    }, 50);
  });

  jQuery("body").on("click", ".closemenu, .closecart", function (e) {
    if (jQuery(this).closest(".colSidebar").length) {
      return false;
    }
    e.preventDefault();
    jQuery("body").removeClass("menuOpen");
    jQuery(".fullPage").removeClass("witmenu");
    jQuery("body").removeClass("filterOpen");
    jQuery("body").removeClass("cartOpen");
    opend_pop.focus();
  });
  jQuery(".menu-overlay").on("click", function (e) {
    e.preventDefault();
    jQuery("body").removeClass("menuOpen");
    jQuery(".fullPage").removeClass("witmenu");
    jQuery("body").removeClass("filterOpen");
    jQuery("body").removeClass("cartOpen");
  });

  jQuery(".mobToggler").on("click", function (e) {
    jQuery(this).next("div").slideToggle();
    jQuery(this).toggleClass("opned");
  });

  function ometria(source, form, email) {
    var settings = {
      url: "https://api.ometria.com/forms/signup/ajax",
      data: form.serialize(),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      type: "post",
      success: function (s) {
        if (s.ok) {
        }
      },
      error: function (e) {
        jQuery(".error").remove();
        if (data.statusText == "BAD REQUEST") {
          form
            .parent()
            .append('<p class="error">The email already subsribed!</p>');
        }
      },
    };

    jQuery.ajax(settings).done(function (response) {
      if (source.indexOf("Footer") > 0) {
        window.location = "/account/register?email=" + email;
      } else {
        form.hide();
        form
          .parent()
          .append(
            '<p style="text-align:center;">Thanks for joining. Please check email for discount code.</p>'
          );
      }
    });
  }
  // footer newsletter
  jQuery("#footerNewsletter").submit(function (event) {
    //this will prevent the default submit
    event.preventDefault();
    jQuery(".error").remove();
    var email = jQuery("#footer-email").val();
    var source = "Site Signups (Footer)";
    var form = jQuery(this);
    var x = true;
    var flag = 1;
    jQuery(".err-msg").remove();
    var em = form.find("#footer-email");
    console.log(em);
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (em.val().trim() == "" || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail...</p>');
      x = false;
      return false;
    } else {
      em.parent().find(".err-msg").remove();

      if (form.find(".alreadyLoggedIn").length) {
        ometria(source, form, email);
        return false;
      }
      ometria(source, form, email);
    }
  });

  $(".head-links a").click(function () {
    if (!$(this).hasClass("inactive-link") && !$(this).hasClass("selected")) {
      $(".head-links a").each(function () {
        $(this).removeClass("selected");
      });

      $(this).addClass("selected");

      var y = $(this).attr("id");

      if ($(this).hasClass("all")) {
        $(".toggle-item").each(function () {
          if (!$(this).hasClass("inactive")) {
            $(this).css("display", "block");
          }
        });
        $(".back-to-top").css("display", "inline");
      } else {
        $(".back-to-top").css("display", "none");
        $(".toggle-item").each(function () {
          if ($(this).hasClass("toggle-item-" + y)) {
            $(this).css("display", "block");
          } else {
            $(this).css("display", "none");
          }
        });
      }
    }
    return false;
  });

  $(".back-to-top a").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#cachedTC_TCArea_1").offset().top,
      },
      500
    );
  });

  $("body").on("change input keyup", ".update_ue_email", function () {
    var parent = $(this).parents("#create_customer");
    var val = $(this).val();
    parent.find('input[name="ue"]').val(val);
  });

  function checkMarket() {
    
  }
  if ($("#marketing").length) {
    checkMarket();
  }

  $("body").on("change", "#marketing", function () {
    checkMarket();
  });

  jQuery("#create_customer").submit(function (event) {
    event.preventDefault();
    var x = false;
    jQuery(this).find(".err-msg").remove();
    var fn = jQuery(this).find("#first_name");
    var em = jQuery(this).find("#email");
    var ln = jQuery(this).find("#last_name");
    var ps = jQuery(this).find("#password");
    var return_to = jQuery(this).find("#return_to");

    
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if(em.val().trim() == '' || !regex.test(em.val())) {
        x = true;
      }
      if(ps.val().trim() == '' || fn.val().trim() == '' || ln.val().trim() == '' || em.val().trim() == '' || x ) {
        return_to.val('/account/register?newcreat=true');
      }
    
    return false;
  });

  var cnt_yotpo_fimd = 0;
  function yotpo_refferal_page_title() {
    cnt_yotpo_fimd++;
    if (cnt_yotpo_fimd > 20) {
      return false;
    }
    if (
      $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title'
      ).length > 0
    ) {
      if ($(".yotpo-logged-in-customer").length)
        $(
          '.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title'
        ).html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/LOGO_ON_WHITE_fca4eb23-117e-48ff-9180-16c8855258ef_300x.png?v=1647854305' alt='' class='yotpo_title_image'>"
        );
      else
        $(
          '.yotpo-widget-instance-container[yotpo-instance-id="18278"] .yotpo-title'
        ).html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/imgpsh_fullsize_anim.png?v=1646993105' alt='' class='yotpo_title_image'>"
        );
      return;
    } else {
      setTimeout(function () {
        yotpo_refferal_page_title();
      }, 500);
    }
  }

  yotpo_refferal_page_title();
  var cnt_yotpo_fimd_1 = 0;
  function yotpo_refferal_page_vip_table() {
    cnt_yotpo_fimd_1++;
    if (cnt_yotpo_fimd_1 > 20) {
      return false;
    }
    if (
      $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18279"] .yotpo-vip-tiers-grid-container'
      ).length > 0
    ) {
      $(".yotpo-grid-vip-tier-container:nth-child(2)")
        .find(".yotpo-vip-tier-icon-wrapper img")
        .attr("alt", "SM-Pass Insider");
      $(".yotpo-grid-vip-tier-container:nth-child(3)")
        .find(".yotpo-vip-tier-icon-wrapper img")
        .attr("alt", "SM-Pass VIP");
      $(".yotpo-grid-vip-tier-container:nth-child(4)")
        .find(".yotpo-vip-tier-icon-wrapper img")
        .attr("alt", "SM-Pass Superstar");
      $(".yotpo-grid-vip-tier-container:nth-child(5)")
        .find(".yotpo-vip-tier-icon-wrapper img")
        .attr("alt", "SM-Pass Icon");

      var columns = $(".yotpo-grid-vip-tier-container");
      var all_rows_0 = $(".yotpo-grid-vip-tier-container:nth-child(2)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_0)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/ORANGE_STAR_1e7306fe-2a3b-47ed-870e-7a14908acf83.png?v=1683519258'>"
        );
      $(all_rows_0[0]).find("p").html("<h1>20%</h1>");
      $(all_rows_0[1]).find("p").html("FREE SHIPPING OVER $50");
      $(all_rows_0[3]).find("p").html("<h1>$15</h1>");

      var all_rows_1 = $(".yotpo-grid-vip-tier-container:nth-child(3)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_1)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/PINK_STAR_3b61df50-9d74-457a-9c68-040abb275d3c.png?v=1683519258'>"
        );
      $(all_rows_1[0]).find("p").html("<h1>20%</h1>");
      $(all_rows_1[1]).find("p").html("FREE 2-DAY OVER $50");
      $(all_rows_1[3]).find("p").html("<h1>$20</h1>");

      var all_rows_2 = $(".yotpo-grid-vip-tier-container:nth-child(4)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_2)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/GREEN_STAR_9980a43e-9e99-4bb3-b279-f545c206c0c0.png?v=1683519258'>"
        );
      $(all_rows_2[0]).find("p").html("<h1>25%</h1>");
      $(all_rows_2[1]).find("p").html("FREE 2-DAY SHIPPING");
      $(all_rows_2[3]).find("p").html("<h1>$30</h1>");

      var all_rows_3 = $(".yotpo-grid-vip-tier-container:nth-child(5)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_3)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/BLUE_STAR_cfde5154-e288-47a2-9ee5-0a38cfb06b43.png?v=1683519258'>"
        );
      $(all_rows_3[0]).find("p").html("<h1>30%</h1>");
      $(all_rows_3[1]).find("p").html("FREE 2-DAY SHIPPING");
      $(all_rows_3[3]).find("p").html("<h1>$40</h1>");

      var all_rows_0_mob = $(".VueCarousel-slide:nth-child(1)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_0_mob)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/ORANGE_STAR_1e7306fe-2a3b-47ed-870e-7a14908acf83.png?v=1683519258'>"
        );
      $(all_rows_0_mob[0]).addClass("not_add").find("p").html("<h1>20%</h1>");
      $(all_rows_0_mob[1])
        .addClass("not_add")
        .find("p")
        .html("FREE SHIPPING OVER $50");
      $(all_rows_0_mob[3]).addClass("not_add").find("p").html("<h1>$15</h1>");

      var all_rows_1_mob = $(".VueCarousel-slide:nth-child(2)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_1_mob)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/PINK_STAR_3b61df50-9d74-457a-9c68-040abb275d3c.png?v=1683519258'>"
        );
      $(all_rows_1_mob[0]).find("p").html("<h1>20%</h1>");
      $(all_rows_1_mob[1]).find("p").html("FREE 2-DAY OVER $50");
      $(all_rows_1_mob[3]).find("p").html("<h1>$20</h1>");

      var all_rows_2_mob = $(".VueCarousel-slide:nth-child(3)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_2_mob)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/GREEN_STAR_9980a43e-9e99-4bb3-b279-f545c206c0c0.png?v=1683519258'>"
        );
      $(all_rows_2_mob[0]).find("p").html("<h1>25%</h1>");
      $(all_rows_2_mob[1]).find("p").html("FREE 2-DAY SHIPPING");
      $(all_rows_2_mob[3]).find("p").html("<h1>$30</h1>");

      var all_rows_3_mob = $(".VueCarousel-slide:nth-child(4)").find(
        ".yotpo-vip-tiers-grid-benefit-status"
      );
      $(all_rows_3_mob)
        .find("p")
        .html(
          "<img src='https://cdn.shopify.com/s/files/1/2170/8465/files/BLUE_STAR_cfde5154-e288-47a2-9ee5-0a38cfb06b43.png?v=1683519258'>"
        );
      $(all_rows_3_mob[0]).find("p").html("<h1>30%</h1>");
      $(all_rows_3_mob[1]).find("p").html("FREE 2-DAY SHIPPING");
      $(all_rows_3_mob[3]).find("p").html("<h1>$40</h1>");

      return;
    } else {
      setTimeout(function () {
        yotpo_refferal_page_vip_table();
      }, 500);
    }
  }

  yotpo_refferal_page_vip_table();

  $("body").on("click", ".yotpo-vip-tiers-grid-benefit-toggle", function (e) {
    cnt_yotpo_fimd_1 = 0;
    yotpo_refferal_page_vip_table();
  });

  // Accessibility 06-02-23
  // Yotpo replace with <h2> tags - SV
  var cnt_yotpo_fimd_2 = 0;
  function yotpo_campaign_table_title() {
    cnt_yotpo_fimd_2++;
    if (cnt_yotpo_fimd_2 > 20) {
      return false;
    }
    if (
      $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-container-headline'
      ).length > 0 &&
      $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-headline-center-element'
      ).length > 0
    ) {
      var heading = $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-container-headline'
      ).html();
      $(".yotpo-container-headline").replaceWith(
        '<h2 class="yotpo-container-headline">' + heading + "</h2>"
      );

      var subtextWrap = $(
        '.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-headline-center-element'
      );
      $.each(subtextWrap, function (ind, val) {
        var subtext = $(val).find(".yotpo-title-text").html();
        $(val)
          .find(".yotpo-title-text")
          .replaceWith('<h3 class="yotpo-title-text">' + subtext + "</h3>");
      });
      // var subtext = $('.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-headline-center-element').find('.yotpo-title-text').html();
      // $('.yotpo-widget-instance-container[yotpo-instance-id="18283"] .yotpo-headline-center-element')
      return;
    } else {
      setTimeout(function () {
        yotpo_campaign_table_title();
      }, 500);
    }
  }
  yotpo_campaign_table_title();
  // Accessibility 06-02-23

  function wishlist_load() {
    if ($(".wishlist_mini .swym-loaded").length > 0) {
      $(".wishlist_mini .swym-loaded").css("visibility", "visible");
    } else {
      setTimeout(function () {
        wishlist_load();
      }, 2000);
    }
  }

  if ($("body").attr("data-count") > 0) {
    wishlist_load();
  }

  jQuery(".removeclick").on("click", function (e) {
    e.preventDefault();
    ManageCookie("smpasspluscart", null, { expires: -1 });
  });

  var smpasspluscart = getCookie("smpasspluscart");
  if (smpasspluscart == "true") {
    addLoyaltyPlusCardRemove("31175889813594", 0, "");
    setTimeout(function () {
      ManageCookie("smpasspluscart", null, -1);
    }, 1000);
  }

  $("body").on("click", ".product-single__quantity .adjust", function (e) {
    e.preventDefault();
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    var event = "";
    var textInt = parseInt(input.val());
    if ($(this).hasClass("plus-symbol")) {
      ip = ip + 1;
      event = "add";
    } else {
      ip = ip - 1;
      event = "remove";
    }
    if (ip == 0) {
      return false;
    }

    //----------------10 Max Qty--------------------------
    var cartTotal = 0;
    $(".cartItemProducts input[name='updates[]']").each(function () {
      cartTotal += parseInt($(this).val());
    });

    if (event == "add") {
      cartTotal++;
    } else {
      cartTotal--;
    }

    if (cartTotal > 10) {
      if (jQuery(".restrictAddToCartError").length == 0) {
        jQuery("#cartform").prepend(
          '<span id="restrictAddToCartError" class="one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
        );
        jQuery(".purchase").prepend(
          '<span id="restrictAddToCartError" class="four restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
        );
      }

      ip = textInt;
      input.val(ip);
      return false;
    } else {
      jQuery(".restrictAddToCartError").remove();
    }
    //--------------------10 Max Qty------------------------------
    input.val(ip);
    $(".main_cart_wrap").addClass("loading");
    var li = input.data("line");
    var id = parseInt(input.attr("data-id"));
    var item = [];
    $.getJSON("/cart.js", function (cart) {
      var c = $(cart.items).filter(function (index, cont) {
        return cont.id == id;
      });
      item.push(c[0]);
    });
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { line: li, quantity: ip },
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        // var response = jQuery.parseJSON(jqXHR.responseText);
        console.log(jqXHR);
        // location.reload();
      },
      success: function (data) {
        function callback() {
          addToCartPageSuccess();
          setTimeout(function () {
            item_count(item[0], event, ip);
          }, 1000);
          setTimeout(function () {
            $(".wishlist_mini .swym-loaded").css("visibility", "visible");
          }, 1000);
        }
        addRemoveGiftsFromCart(callback);
      },
    });
  });

  function addShoppinggiveLabel() {
    if (
      $(".shoppinggives-tag").length != 0 &&
      $(".sg-addon-main-text").length != 0 &&
      $(".sg-addon-title").length != 0
    ) {
      $(".sg-add-on-donation").each(function (i, ele) {
        if ($(ele).hasClass("selected-addon")) {
          $(ele).attr("aria-current", true);
        } else {
          $(ele).attr("aria-current", false);
        }
      });
      $(".sg-addon-title").replaceWith(
        '<h2 class="sg-addon-title">SM GIVES</h2>'
      );
      $(".sg-addon-main-text span").removeAttr("tabindex");

      var target = document.querySelector(".sg-widget");

      var observer = new MutationObserver(function (mutations) {
        $(".sg-add-on-donation").each(function (i, ele) {
          if ($(ele).hasClass("selected-addon")) {
            $(ele).attr("aria-current", true);
          } else {
            $(ele).attr("aria-current", false);
          }
        });
        $(".sg-addon-title").replaceWith(
          '<h2 class="sg-addon-title">SM GIVES</h2>'
        );
        $(".sg-addon-main-text span").removeAttr("tabindex");
      });

      observer.observe(target, {
        childList: true,
        characterData: true,
      });
    } else {
      setTimeout(addShoppinggiveLabel, 200);
    }
  }
  addShoppinggiveLabel();

  function addToCartSuccess() {
    $.get("/cart?view=mini", function (data) {
      // var html_all = $(data).find('.cart-data').html();
      // $('#crt').html(html_all);

      var new_data = data.split("[cartsplit]");
      $("body #crt .quick-item-wrap[data-cart-items]").html(new_data[0]);
      $("body #crt .cartTotal[data-cart-subtotal]").html(new_data[1]);

      if ($("#crt").find(".emptyCart").length == 0) {
        $(".cartButtonOuter").show().parents(".cart-data").addClass("has-item");
      } else {
        $(".cartButtonOuter")
          .hide()
          .parents(".cart-data")
          .removeClass("has-item");
      }
      cartCollectionSlider();
      $("#crt").removeClass("loading");

      $(".wishlist_mini .swym-loaded").css("visibility", "visible");
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
      addShoppinggiveLabel();
    });
  }

  function addToCartPageSuccess() {
    $.get(window.location.pathname, function (data) {
      $.getJSON("/cart.js", function (cart) {
        if (cart.item_count == 0) {
          var cartHtml = $(data).find(".main_cart_wrap").html();
          $(".main_cart_wrap").html(cartHtml);
        } else {
          var itemHtml = $(data).find(".cartItemProducts").html();
          var sideHtml = $(data).find(".cartTotalSide").html();
          $(".cartItemProducts").html(itemHtml);
          $(".cartTotalSide").html(sideHtml);
          $(".wishlist_mini .swym-loaded").css("visibility", "visible");
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
          }
        }
        $(".main_cart_wrap").removeClass("loading");
      });
    });
  }

  function viewCartEvent() {
    window.dataLayer.push({
      event: "viewedSideCart",
      _clear: true,
    });
  }

  function item_count(data, event, ip) {
    // console.log(data, '55555');
    if (data) {
      var IsPreOrder = false;
      var IsBackOrder = false;
      if (
        typeof data.properties !== "undefined" &&
        data.properties !== null &&
        data.properties != ""
      ) {
        if (
          typeof data.properties["Pre-ordered items"] !== "undefined" &&
          data.properties["Pre-ordered items"] != null &&
          data.properties["Pre-ordered items"] != ""
        ) {
          if (data.properties["Pre-ordered items"] == 1) {
            IsPreOrder = true;
          }
        }
        if (typeof data.properties["Back-ordered items"] !== "undefined") {
          if (data.properties["Back-ordered items"] == 1) {
            IsBackOrder = true;
          }
        }
      }
      var dataEvent = {
        event: "updateCart",
      };
      if (ip) {
        var qty = 1;
      } else {
        var qty = data.quantity;
      }
      if (event == "add") {
        dataEvent.addToCart = {
          products: [
            {
              id: data.product_id,
              sku: data.variant_id,
              style: data.sku,
              name: data.title,
              price: (parseInt(data.final_price) / 100).toFixed(2),
              basePrice: (parseInt(data.original_price) / 100).toFixed(2),
              quantity: qty, // or -1 if remove
              brand: data.vendor,
              upc: data.properties ? data.properties.UPC : "",
              IsPreOrder: IsPreOrder,
              IsBackOrder: IsBackOrder,
              color:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "color"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "color"
                      )
                    ].trim()
                  : "",
              colorFamily:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "color"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "color"
                      )
                    ].trim()
                  : "",
              size:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "size"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "size"
                      )
                    ].trim()
                  : "",
              expectedShipDate: data.properties
                ? data.properties["EXPECTED SHIP DATE"]
                : "",
              category: data.product_type,
            },
          ],
        };
      } else {
        dataEvent.removeFromCart = {
          products: [
            {
              id: data.product_id,
              sku: data.variant_id,
              style: data.sku,
              name: data.title,
              price: (parseInt(data.final_price) / 100).toFixed(2),
              basePrice: (parseInt(data.original_price) / 100).toFixed(2),
              quantity: qty, // or -1 if remove
              brand: data.vendor,
              upc: data.properties ? data.properties.UPC : "",
              IsPreOrder: IsPreOrder,
              IsBackOrder: IsBackOrder,
              color:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "color"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "color"
                      )
                    ].trim()
                  : "",
              colorFamily:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "color"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "color"
                      )
                    ].trim()
                  : "",
              size:
                data.options_with_values.findIndex(
                  (x) => x["name"].toLowerCase() == "size"
                ) != -1
                  ? data.variant_options[
                      data.options_with_values.findIndex(
                        (x) => x["name"].toLowerCase() == "size"
                      )
                    ].trim()
                  : "",
              expectedShipDate: data.properties
                ? data.properties["EXPECTED SHIP DATE"]
                : "",
              category: data.product_type,
            },
          ],
        };
      }

      $.getJSON("/cart.js", function (c) {
        $(".cartCount").text(c.item_count);
        dataEvent.cart = {
          total: c.total_price,
          count: c.item_count,
          products: [],
        };
        $(c.items).each(function (i, v) {
          var CIsPreOrder = false;
          var CIsBackOrder = false;
          if (
            typeof v.properties !== "undefined" &&
            v.properties !== null &&
            v.properties != ""
          ) {
            if (
              typeof v.properties["Pre-ordered items"] !== "undefined" &&
              v.properties["Pre-ordered items"] != null &&
              v.properties["Pre-ordered items"] != ""
            ) {
              if (v.properties["Pre-ordered items"] == 1) {
                CIsPreOrder = true;
              }
            }
            if (typeof v.properties["Back-ordered items"] !== "undefined") {
              if (v.properties["Back-ordered items"] == 1) {
                CIsBackOrder = true;
              }
            }
          }
          dataEvent.cart.products.push({
            id: v.product_id,
            sku: v.variant_id,
            style: v.sku,
            name: v.title,
            price: (parseInt(v.final_price) / 100).toFixed(2),
            basePrice: (parseInt(v.original_price) / 100).toFixed(2),
            quantity: v.quantity, // or -1 if remove
            brand: v.vendor,
            upc: v.properties ? v.properties.UPC : "",
            IsPreOrder: CIsPreOrder,
            IsBackOrder: CIsBackOrder,
            color:
              v.options_with_values.findIndex(
                (x) => x["name"].toLowerCase() == "color"
              ) != -1
                ? v.variant_options[
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    )
                  ].trim()
                : "",
            colorFamily:
              v.options_with_values.findIndex(
                (x) => x["name"].toLowerCase() == "color"
              ) != -1
                ? v.variant_options[
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    )
                  ].trim()
                : "",
            size:
              v.options_with_values.findIndex(
                (x) => x["name"].toLowerCase() == "size"
              ) != -1
                ? v.variant_options[
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "size"
                    )
                  ].trim()
                : "",
            expectedShipDate: v.properties
              ? v.properties["EXPECTED SHIP DATE"]
              : "",
            category: v.product_type,
          });
        });
        dataEvent._clear = true;
        window.dataLayer.push(dataEvent);
      });
    }
  }

  $("body").on(
    "click",
    ".close-icon, .count-shopping, .continue_shop_reboot",
    function (e) {
      jQuery(".rebooted_popup").removeClass("active");
      jQuery(".stlPopupCont").html(
        '<img class="stlLoading" src="https://cdn.shopify.com/s/files/1/2170/8465/files/Reload.svg?v=1614273530" alt="" />'
      );
      jQuery("body").removeClass("popupOpned");
      jQuery("#stl-cont").hide();
      if (parseInt(jQuery("#stl-cont").attr("data-addcnt")) > 0) {
        $("body").addClass("cartOpen");
        $(".fullPage").addClass("witmenu");
        jQuery("#stl-cont").attr("data-addcnt", 0);
        // viewCartEvent();
        $.getJSON("/cart.js", function (c) {
          $(".cartCount").text(c.item_count);
          addtocart_button_reboot_normal();
        });
      }
      $("body").removeClass("full_height");
      $(".stl-popup").removeClass("full_height");
      if ($(".topbar-rolling-text.slick-initialized").length) {
        $(".topbar-rolling-text.slick-initialized").slick("refresh");
      }
    }
  );
  $("body").on("click", ".close-error, .close_nd_animate", function () {
    $(".error-popup").hide();
    $("body").removeClass("select_size_popup");
    $(".stlpopup-wrap.active").find(".cart-button").prop("disabled", false);
    $(
      ".stlpopup-wrap.active .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop"
    ).addClass("pulse");
    setTimeout(function () {
      $(
        ".stlpopup-wrap .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop"
      ).removeClass("pulse");
    }, 1000);
  });

  $("body").on("click", ".addtocartsmpassplus", function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest("form");
    btn.attr("disabled", "disabled");

    if (AddToCartQuantityMaxLimit()) {
      return false;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form
            .append('<p class="error">' + response.description + "</p>")
            .find(".error")
            .fadeIn()
            .delay(4000)
            .fadeOut();
        }
      },
    }).done(function (data) {
      var IsPreOrder = false;
      var IsBackOrder = false;
      if (data.properties["Pre-ordered items"] == 1) {
        IsPreOrder = true;
      }
      if (data.properties["Back-ordered items"] == 1) {
        IsBackOrder = true;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "addToCart",
        addToCartLocation: "SM PASS PLUS",
        addToCart: {
          product: {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price) / 100).toFixed(2),
            basePrice: (parseInt(data.original_price) / 100).toFixed(2),
            quantity: data.quantity,
            brand: data.vendor,
            upc: data.properties.UPC,
            IsPreOrder: IsPreOrder,
            IsBackOrder: IsBackOrder,
            expectedShipDate: data.properties["EXPECTED SHIP DATE"],
            // color: data.variant_options[0].trim(),
            // colorFamily: data.variant_options[0].trim(),
            // size:data.variant_options[1].trim(),
          },
        },
        data: data,
      });
      Cookies.set("smpasspluscart", true, { expires: 7 });
      window.location.href = "/checkout";
    });
  });

  var isAddToCartNotInProgress = true;
  function disableIsAddToCartNotInProgress() {
    setTimeout(function () {
      isAddToCartNotInProgress = true;
    }, 1000);
  }

  jQuery("body").on("click", ".addtocart", function (e) {
    console.log("add to cart quick cart");
    e.preventDefault();
    var btn = jQuery(this),
      addToCartLocation = "";
    var form = jQuery(this).closest("form");

    if ($(this).closest(".cutsom_button").hasClass("ProductStickyAddToCart")) {
      if (
        form.find(".swatch.select_size input[type=radio]:checked").length <= 0
      ) {
        window.scroll({
          top: form.find(".swatch.select_size").offset().top,
          left: 0,
          behavior: "smooth",
        });
        return false;
      }
    }

    form.find(".error").remove();
    if (btn.hasClass("quickAdd")) {
      addToCartLocation = "Quick View";
    } else {
      addToCartLocation = "Product Page";
    }

    if (form.find(".product-normal.select_size").length) {
      if (!form.find(".select_size").find("input:checked").length) {
        if (btn.hasClass("quickAdd")) {
          btn
            .parents(".purchase-section")
            .append('<p class="error">Please select size.</p>')
            .find(".error")
            .fadeIn()
            .delay(4000)
            .fadeOut();
        } else {
          btn
            .parents(".cutsom_button")
            .append('<p class="error">Please select size.</p>')
            .find(".error")
            .fadeIn()
            .delay(4000)
            .fadeOut();
        }
        return false;
      }
    }
    jQuery.get("/cart?view=check_used", function (data) {
      var final_data = JSON.parse(data);
      if (final_data.has_used && !$("body.used_pdp").length) {
        $("body").addClass("used_condition_occur");
        $(".cartCount").text(final_data.cart_count);
      } else if (final_data.has_normal && $("body.used_pdp").length) {
        $("body").addClass("used_condition_occur");
        $(".cartCount").text(final_data.cart_count);
      } else {
        $("body").removeClass("used_condition_occur");
        form.find(".error").remove();
        if (
          (form.find(".selector-wrapper.is-size").length &&
            form
              .find(".selector-wrapper.is-size")
              .find(".single-option-selector")
              .val() == null) ||
          form
            .find(".selector-wrapper.is-size")
            .find(".single-option-selector")
            .val() == ""
        ) {
          $("body").addClass("select_size_popup");
          $(".error-popup").show();
          return false;
        }
        if (typeof item !== "undefined") {
          _learnq.push(["track", "Added to Cart", item]);
        }

        if (AddToCartQuantityMaxLimit()) {
          console.log("max limit reached");
          upsellDatalayer();
          return false;
        }
        if (isAddToCartNotInProgress) {
          isAddToCartNotInProgress = false;
          var pickup = $('[name="pickupRadio"]:checked');
          if (pickup.length) {
            if (pickup.val() == "nextday" || pickup.val() == "sameday") {
              if (
                localStorage.getItem("pickupZipCode") == null ||
                localStorage.getItem("pickupZipCode") == ""
              ) {
                var zipinputSame = pickup
                  .closest(".zipNeedWrap")
                  .find(".zipcodeinput");
                var zipinput = pickup
                  .closest(".zipNeedWrap")
                  .find(".zipcodeinput2");
                if (pickup.val() == "sameday") {
                  if (zipinputSame.val() == "") {
                    zipinputSame.css("border-bottom", "1px solid red").focus();
                    form
                      .append('<p class="error">Please add zip code.</p>')
                      .find(".error")
                      .fadeIn()
                      .delay(4000)
                      .fadeOut();
                    return false;
                  } else {
                    localStorage.setItem("pickupZipCode", zipinputSame.val()); // used on checkout page // removed on thank you page
                  }
                }
                if (pickup.val() == "nextday") {
                  if (zipinput.val() == "") {
                    zipinput.css("border-bottom", "1px solid red").focus();
                    form
                      .append('<p class="error">Please add zip code.</p>')
                      .find(".error")
                      .fadeIn()
                      .delay(4000)
                      .fadeOut();
                    return false;
                  } else {
                    localStorage.setItem("pickupZipCode", zipinput.val()); // used on checkout page // removed on thank you page
                  }
                }
              }
            }
          }
          btn.attr("disabled", "disabled");
          btn.val("Προστίθεται...");
          btn.find(".cart-text").text("Προστίθεται...");
          var text = btn.attr("data-lable");
          $(".product_quickview, .overlay").removeClass("active");
          $("body").removeClass("Fixed");
          jQuery
            .ajax({
              type: "POST",
              url: "/cart/add.js",
              data: form.serialize(),
              dataType: "json",
              error: function (jqXHR, textStatus, errorThrown) {
                disableIsAddToCartNotInProgress();
                if (jqXHR) {
                  var response = jQuery.parseJSON(jqXHR.responseText);
                  form
                    .append('<p class="error">' + response.description + "</p>")
                    .find(".error")
                    .fadeIn()
                    .delay(4000)
                    .fadeOut();
                }
                btn.val(text);
                btn.find(".cart-text").text(text);
                btn.removeAttr("disabled");
              },
            })
            .done(function (data) {
              function callback() {
                disableIsAddToCartNotInProgress();
                var IsPreOrder = false;
                var IsBackOrder = false;
                if (
                  typeof data.properties !== "undefined" &&
                  data.properties !== null &&
                  data.properties != ""
                ) {
                  if (
                    typeof data.properties["Pre-ordered items"] !==
                      "undefined" &&
                    data.properties["Pre-ordered items"] != null &&
                    data.properties["Pre-ordered items"] != ""
                  ) {
                    if (data.properties["Pre-ordered items"] == 1) {
                      IsPreOrder = true;
                    }
                  }
                  if (
                    typeof data.properties["Back-ordered items"] !== "undefined"
                  ) {
                    if (data.properties["Back-ordered items"] == 1) {
                      IsBackOrder = true;
                    }
                  }
                }
                window.dataLayer = window.dataLayer || [];
                if (
                  form.find('[type="application/json"].form_script').length > 0
                ) {
                  var productData = JSON.parse(
                    form.find('[type="application/json"].form_script').text()
                  );
                }

                window.dataLayer.push({
                  event: "addToCart",
                  addToCartLocation: addToCartLocation,
                  addToCart: {
                    product: {
                      id: data.product_id,
                      sku: data.variant_id,
                      style: data.sku,
                      name: data.title,
                      price: (parseInt(data.final_price) / 100).toFixed(2),
                      basePrice: (parseInt(data.original_price) / 100).toFixed(
                        2
                      ),
                      quantity: data.quantity,
                      brand: data.vendor,
                      type: data.product_type,
                      tags: productData ? productData.tags : data.tags,
                      upc: form.find("#productbarcode").val(),
                      IsPreOrder: IsPreOrder,
                      IsBackOrder: IsBackOrder,
                      gatedToken:
                        data.properties != null &&
                        typeof data.properties.gatedToken != "undefined"
                          ? data.properties.gatedToken
                          : "",
                      color:
                        data.options_with_values.findIndex(
                          (x) => x["name"].toLowerCase() == "color"
                        ) != -1
                          ? data.variant_options[
                              data.options_with_values.findIndex(
                                (x) => x["name"].toLowerCase() == "color"
                              )
                            ].trim()
                          : "",
                      colorFamily:
                        data.options_with_values.findIndex(
                          (x) => x["name"].toLowerCase() == "color"
                        ) != -1
                          ? data.variant_options[
                              data.options_with_values.findIndex(
                                (x) => x["name"].toLowerCase() == "color"
                              )
                            ].trim()
                          : "",
                      size:
                        data.options_with_values.findIndex(
                          (x) => x["name"].toLowerCase() == "size"
                        ) != -1
                          ? data.variant_options[
                              data.options_with_values.findIndex(
                                (x) => x["name"].toLowerCase() == "size"
                              )
                            ].trim()
                          : "",
                      expectedShipDate: form.find("#preordermessage").val(),
                    },
                  },
                });
                btn.val(text);
                btn.find(".cart-text").text(text);
                btn.removeAttr("disabled");
                addToCartSuccess();
                item_count(data, "add");
                jQuery("body").addClass("cartOpen");
                jQuery(".fullPage").addClass("witmenu");
                viewCartEvent();
                var all_added = jQuery("body").attr("total_add_n_pdp");
                if (
                  typeof all_added !== "undefined" &&
                  all_added != null &&
                  all_added != ""
                ) {
                  jQuery("body").attr("total_add_n_pdp", Number(all_added) + 1);
                } else {
                  jQuery("body").attr("total_add_n_pdp", 1);
                }
                jQuery(".cart-count").text(
                  jQuery("body").attr("total_add_n_pdp")
                );
                setTimeout(function () {
                  $(".wishlist_mini .swym-loaded").css("visibility", "visible");
                }, 1000);
                opend_pop = btn;
                setTimeout(function () {
                  $(".cartDrawer").focus();
                }, 500);
                upsellDatalayer();
                document.dispatchEvent(new CustomEvent("addTrack"));
              }
              addRemoveGiftsFromCart(callback);
            });
        }
      }
    });
  });

  $("body").on("click", ".quick-cart-details .adjust", function (e) {
    e.preventDefault();
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    var event = "";
    var elementClass = "minus";
    var initialVal = parseInt(input.val());
    if ($(this).hasClass("plus")) {
      ip = ip + 1;
      event = "add";
      elementClass = "plus";
    } else {
      ip = ip - 1;
      event = "remove";
    }
    if (ip == 0) {
      return false;
    }

    if (AjaxAddToCartQuantityMaxLimit(elementClass)) {
      input.val(initialVal);
      return false;
    }

    input.val(ip);
    var li = input.data("line");
    $("#crt").addClass("loading");
    var id = parseInt(input.attr("data-id"));
    var item = [];
    $.getJSON("/cart.js", function (cart) {
      var c = $(cart.items).filter(function (index, cont) {
        return cont.id == id;
      });
      item.push(c[0]);
    });
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { line: li, quantity: ip },
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        var response = jQuery.parseJSON(jqXHR.responseText);
        console.log(response.message);
        addToCartSuccess();
        setTimeout(function () {
          $(".wishlist_mini .swym-loaded").css("visibility", "visible");
        }, 1000);
        $("#crt").removeClass("loading");
      },
      success: function (data) {
        function callback() {
          addToCartSuccess();
          setTimeout(function () {
            item_count(item[0], event, ip);
          }, 1000);
          addtocart_button_reboot_normal();
          setTimeout(function () {
            $(".wishlist_mini .swym-loaded").css("visibility", "visible");
          }, 1000);
          $("#crt").removeClass("loading");
        }
        addRemoveGiftsFromCart(callback);
      },
    });
  });

  $("body").on("click", ".upsell_add", function (e) {
    e.preventDefault();
    if (!CheckMaxCart()) {
      return false;
    }

    if (isAddToCartNotInProgress) {
      isAddToCartNotInProgress = false;
      var btn = $(this);
      var id = btn.attr("data-id");
      var barcode = btn.attr("data-barcode");
      var div = $(this).parents("._product");
      btn.attr("disabled", "disabled");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: id, qauntity: 1, properties: { UPC: barcode } },
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown) {
          disableIsAddToCartNotInProgress();
          var response = $.parseJSON(jqXHR.responseText);
          div
            .append('<p class="error">' + response.description + "</p>")
            .find(".error")
            .fadeIn()
            .delay(4000)
            .fadeOut();
          btn.removeAttr("disabled");
        },
        success: function (data) {
          function callback() {
            disableIsAddToCartNotInProgress();
            var IsPreOrder = false;
            var IsBackOrder = false;
            if (
              typeof data.properties !== "undefined" &&
              data.properties !== null &&
              data.properties != ""
            ) {
              if (
                typeof data.properties["Pre-ordered items"] !== "undefined" &&
                data.properties["Pre-ordered items"] != null &&
                data.properties["Pre-ordered items"] != ""
              ) {
                if (data.properties["Pre-ordered items"] == 1) {
                  IsPreOrder = true;
                }
              }
              if (
                typeof data.properties["Back-ordered items"] !== "undefined"
              ) {
                if (data.properties["Back-ordered items"] == 1) {
                  IsBackOrder = true;
                }
              }
            }
            var expectedShipDate =
              data.properties != null
                ? data.properties["EXPECTED SHIP DATE"] != null
                  ? data.properties["EXPECTED SHIP DATE"]
                  : ""
                : "";
            var upc =
              data.properties != null
                ? data.properties["UPC"] != null
                  ? data.properties["UPC"]
                  : ""
                : "";
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "addToCart",
              addToCartLocation: "Mini-Cart",
              addToCart: {
                product: {
                  id: data.product_id,
                  sku: data.variant_id,
                  style: data.sku,
                  name: data.title,
                  price: (parseInt(data.final_price) / 100).toFixed(2),
                  basePrice: (parseInt(data.original_price) / 100).toFixed(2),
                  quantity: data.quantity,
                  brand: data.vendor,
                  upc: upc,
                  IsPreOrder: IsPreOrder,
                  IsBackOrder: IsBackOrder,
                  color:
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    ) != -1
                      ? data.variant_options[
                          data.options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "color"
                          )
                        ].trim()
                      : "",
                  colorFamily:
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    ) != -1
                      ? data.variant_options[
                          data.options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "color"
                          )
                        ].trim()
                      : "",
                  size:
                    data.options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "size"
                    ) != -1
                      ? data.variant_options[
                          data.options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "size"
                          )
                        ].trim()
                      : "",
                  expectedShipDate: expectedShipDate,
                },
              },
            });
            btn.removeAttr("disabled");
            addToCartSuccess();
            item_count(data, "add", 1);
            jQuery("body").addClass("cartOpen");
            jQuery(".fullPage").addClass("witmenu");
            var all_added = jQuery("body").attr("total_add_n_pdp");
            if (
              typeof all_added !== "undefined" &&
              all_added != null &&
              all_added != ""
            ) {
              jQuery("body").attr("total_add_n_pdp", Number(all_added) + 1);
            } else {
              jQuery("body").attr("total_add_n_pdp", 1);
            }
            jQuery(".cart-count").text(jQuery("body").attr("total_add_n_pdp"));
            setTimeout(function () {
              $(".wishlist_mini .swym-loaded").css("visibility", "visible");
            }, 1000);
            opend_pop = btn;
            setTimeout(function () {
              $(".cartDrawer").focus();
            }, 500);
          }
          addRemoveGiftsFromCart(callback);
        },
      });
    }
  });

  $("body").on(
    "change",
    ".stlpopup-wrap .single-option-selector.size",
    function () {
      if ($(this).val() == "") {
        $(this).closest(".stlpopup-wrap").find("#preproperties").remove();
        $(this).closest(".stlpopup-wrap").find(".tooltiptext").hide();
        $(this)
          .closest(".stlpopup-wrap")
          .find('input[name="variant_id"]')
          .val("");
      }
    }
  );

  $(".single-option-selector.size").each(function () {
    if ($(this).val() == "") {
      $(this).closest(".stlpopup-wrap").find("#preproperties").remove();
      $(this).closest(".stlpopup-wrap").find(".tooltiptext").hide();
      $(this)
        .closest(".stlpopup-wrap")
        .find('input[name="variant_id"]')
        .val("");
    }
  });
  $("body").on("click", ".swatchClr", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) return false;

    var a = $(this);
    var u = a.attr("href");
    var pid = a.attr("data-id");
    var pdiv = $(this).closest(".stlpopup-wrap");
    var stl = pdiv.find(".footer-leftcol").html();
    var handle = u + "?view=shopthelook1";
    if ($(".product-v2_product").length) {
      handle = u + "?view=V2_product1";
    }
    var ph = u.replace("/products/");
    jQuery.get(handle, function (data) {
      pdiv.html(data);
      pdiv.attr("data-product", ph).attr("id", "p" + pid);
      pdiv.find(".footer-leftcol").html(stl);
      if ($("body").attr("data-redirection_code") == "true") {
        $(".swatchClr:not(.done)").each(function () {
          var a = $(this);
          var u = a.attr("href");
          $.get(u + "?view=shopthelookClr", function (p) {
            if (p.indexOf("custom_anchore_pdp") > -1) {
              if (p == "") {
                a.hide();
              } else {
                if (a.hasClass("active")) {
                  p.replace("replaceActive", "active");
                }
                a.html(p);
                if (a.hasClass("active")) {
                  var activeimg = $(
                    ".stlpopup-wrap.active .rightcolbody-content .swatchClr.active a"
                  ).html();
                  $(
                    '.stlpopup-footer .trigger-product[data-indx="' +
                      $(".stlpopup-wrap.active").attr("data-indx") +
                      '"]'
                  ).html(activeimg);
                  var p_title = $(
                    ".stlpopup-wrap.active .rightcolbody-content .swatchClr.active a"
                  ).attr("data-p_title");
                  $(".stlpopup-wrap.active .only_p_t").html(p_title);
                }
              }
            } else {
              a.hide();
            }
          }).fail(function () {
            a.remove();
          });
          $(this).addClass("done");
        });
      }
      if ($(window).width() > 1024) {
        $(".stlpopup-wrap .leftcol-wrap .img-wrap").each(function (i, v) {
          $("#" + $(this).attr("id")).zoom();
        });
      }
      if (typeof Yotpo !== "undefined") {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
    });
  });

  $("body").on("click", ".cart-button", function (e) {
    e.preventDefault();
    var t = $(this);
    t.attr("disabled", "disabled");
    var vid = [];
    var v = $("body .stlpopup-wrap.active")
      .find('input[name="variant_id"]')
      .val();
    if (v != "" && v != null && v != undefined) {
      vid.push(v);
    }
    if (vid.length == 0) {
      $(".error-popup").show();
      $("body").addClass("select_size_popup");
      return false;
    } else {
      $(".error-popup").hide();
      $("body").removeClass("select_size_popup");
      let iterations = vid.length;
      var data = [];
      for (var i of vid.reverse()) {
        //if (!--iterations){
        var items = {};
        items.id = i;
        items.quantity = 1;
        var prop = {};
        //         prop['Shop the look'] = window.mptl;
        if ($("body .stlpopup-wrap.active #productbarcode").length) {
          prop["UPC"] = $("body .stlpopup-wrap.active #productbarcode").val();
        }
        if ($("body .stlpopup-wrap.active #preordermessage").length) {
          prop["EXPECTED SHIP DATE"] = $(
            "body .stlpopup-wrap.active #preordermessage"
          ).val();
        }
        if ($("body .stlpopup-wrap.active .back_order_properties").length) {
          prop["Back-ordered items"] = $(
            "body .stlpopup-wrap.active .back_order_properties"
          ).val();
        }
        if ($("body .stlpopup-wrap.active .pre_order_properties").length) {
          prop["Pre-ordered items"] = $(
            "body .stlpopup-wrap.active .pre_order_properties"
          ).val();
        }
        items.properties = prop;
        data.push(items);
      }

      $.post(
        "/cart/add.js",
        {
          items: data,
        },
        function (pro) {
          t.removeAttr("disabled");
          $("#stl-cont").attr(
            "data-addcnt",
            parseInt($("#stl-cont").attr("data-addcnt")) + 1
          );
          $("body .stlpopup-wrap")
            .find(".cart-count")
            .text($("#stl-cont").attr("data-addcnt"));
          window.dataLayer = window.dataLayer || [];
          var c = pro.items[0];
          window.dataLayer.push({
            event: "stl_add_to_cart",
            addToCart: {
              product: {
                id: c.product_id,
                sku: c.variant_id,
                style: c.sku,
                name: c.title,
                price: (parseInt(c.final_price) / 100).toFixed(2),
                basePrice: (parseInt(c.original_price) / 100).toFixed(2),
                quantity: 1,
                brand: c.vendor,
                upc: $("body .stlpopup-wrap.active #productbarcode").val(),
                isPreOrder: Number(
                  $("body .stlpopup-wrap.active .isPreOrder").val()
                ),
                isBackOrder: Number(
                  $("body .stlpopup-wrap.active .back_order_properties").val()
                ),
                color: c.variant_options[0].trim(),
                colorFamily: c.variant_options[0].trim(),
                size: c.variant_options[1].trim(),
                expectedShipDate: $(
                  "body .stlpopup-wrap.active #preordermessage"
                ).val(),
              },
            },
            data: c,
          });
          if ($("body.is_v2_product").length) {
            $("body").addClass("cartOpen");
            $(".fullPage").addClass("witmenu");
            viewCartEvent();
            addToCartSuccess();
            item_count(c, "add");
            addtocart_button_reboot_normal();
          }
          upsellDatalayer();
        },
        "JSON"
      ).fail(function (response) {
        t.removeAttr("disabled");
        alert("Something went wrong...");
      });
    }
  });

  $(".item-quantityg").keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $("body").on("mouseenter, click", ".cartOuter", function (e) {
    if (jQuery(this).find(".cartCount").text() != "0") {
      e.preventDefault();
      setTimeout(function () {
        $("body").addClass("cartOpen");
        $(".fullPage").addClass("witmenu");
        $(".closecart").focus();
      }, 50);
      opend_pop = $(this).find("a");
      setTimeout(function () {
        $(".cartDrawer").focus();
      }, 500);
    }
    viewCartEvent();
  });

  $("body").on("click", ".remove_item", function (e) {
    $("#crt").addClass("loading");
    e.preventDefault();
    var id = $(this).data("id");
    var __this = $(this);
    var updateData = {};
    var data_bundle_id = $(this).attr("data-bundle_id");
    if (data_bundle_id != "") {
      $('.remove_item[data-bundle_id="' + data_bundle_id + '"]').each(function (
        ii,
        vv
      ) {
        updateData[$(vv).data("id")] = 0;
      });
    } else {
      updateData[$(this).data("id")] = 0;
    }

    var item = [];
    $.getJSON("/cart.js", function (cart) {
      var c = $(cart.items).filter(function (index, cont) {
        return cont.id == id;
      });
      item.push(c[0]);
    });
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: {
        updates: updateData,
      },
      async: false,
    }).done(function () {
      if (__this.attr("data-gift") == "yes" && getCookie("Gift") == "") {
        ManageCookie("Gift", "No", 1);
      }
      function callback() {
        addToCartSuccess();
        setTimeout(function () {
          item_count(item[0], "remove");
        }, 1000);
        addtocart_button_reboot_normal();
        setTimeout(function () {
          $(".wishlist_mini .swym-loaded").css("visibility", "visible");
        }, 1000);
        $("#crt").removeClass("loading");
      }
      addRemoveGiftsFromCart(callback);
    });
  });

  $("body").on("click", ".cart_remove", function (e) {
    $(".main_cart_wrap").addClass("loading");
    e.preventDefault();
    var id = $(this).data("id");
    var __this = $(this);
    var updateData = {};
    var data_bundle_id = $(this).parents(".productItem").attr("data-bundle_id");
    if (data_bundle_id != "") {
      $('.productItem[data-bundle_id="' + data_bundle_id + '"]').each(function (
        ii,
        vv
      ) {
        updateData[$(vv).data("id")] = 0;
      });
    } else {
      updateData[id] = 0;
    }

    var item = [];
    $.getJSON("/cart.js", function (cart) {
      var c = $(cart.items).filter(function (index, cont) {
        return cont.id == id;
      });
      item.push(c[0]);
    });

    try {
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/cart/update.js",
        data: {
          updates: updateData,
        },
        async: false,
        success: function (data) {
          console.log("cart remove success");
        },
        error: function (x, y, z) {
          console.log("error on cart remove");
          console.log(x);
        },
      }).done(function () {
        if (__this.attr("data-gift") == "yes" && getCookie("Gift") == "") {
          ManageCookie("Gift", "No", 1);
        }
        function callback() {
          addToCartPageSuccess();
          setTimeout(function () {
            item_count(item[0], "remove");
          }, 1000);
          setTimeout(function () {
            $(".wishlist_mini .swym-loaded").css("visibility", "visible");
          }, 1000);
        }
        addRemoveGiftsFromCart(callback);
      });
    } catch (ex) {
      console.log("error opn cart remove");
      console.log(ex);
    }
  });

  $("body").on("click", ".trigger-product", function (e) {
    e.preventDefault();
    var handle = $(this).attr("data-product");
    var indx = $(this).attr("data-indx");
    var title = $(this).attr("data-title");
    var pid = $(this).attr("data-pid");
    $(".stl-popup").find(".stlpopup-wrap").removeClass("active");
    $(this)
      .closest(".stl-popup")
      .find('.stlpopup-wrap[data-indx="' + indx + '"]')
      .addClass("active");
    $(".trigger-product").removeClass("active");
    var s = $(this).attr("data-product");
    $('.trigger-product[data-product="' + s + '"]').addClass("active");
    if (jQuery(window).width() < 768) {
      if (typeof put_height === "function") {
        put_height();
      }
      $(
        ".product-v2_product .stlpopup-wrap.active .leftcol .leftcol-wrap.slick-initialized"
      ).slick("refresh");
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer = window.dataLayer || [];
    var newid = "dataLayerData_" + pid;
    window.dataLayer.push(window[newid]);
    if (typeof Yotpo !== "undefined") {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }
    get_price();
  });

  $("body").on("click", ".rebooted_readmore a", function (e) {
    e.preventDefault();
    $(this)
      .closest(".right_side_bar")
      .find(".rebooted_desc")
      .addClass("active");
    $(this).closest(".right_side_bar").find(".rebooted_readmore").hide();
    $(this).closest(".right_side_bar").find(".rebooted_readless").show();
  });
  $("body").on("click", ".rebooted_readless a", function (e) {
    e.preventDefault();
    $(this)
      .closest(".right_side_bar")
      .find(".rebooted_desc")
      .removeClass("active");
    $(this).closest(".right_side_bar").find(".rebooted_readmore").show();
    $(this).closest(".right_side_bar").find(".rebooted_readless").hide();
  });
  $("body").on(
    "click",
    ".rebooted_grid_link, .rebootedimg_wrpr a",
    function (e) {
      e.preventDefault();
      $(".preproperties").remove();
      var variant_price = Number(
          $(this).closest(".rebooted_grid").attr("data-variant_price")
        ),
        cmp_variant_price = Number(
          $(this).closest(".rebooted_grid").attr("data-cmp_price")
        ),
        variant_title = $(this)
          .closest(".rebooted_grid")
          .attr("data-var-pro_title"),
        popup_data = "",
        is_pre_order = $(this).closest(".rebooted_grid").attr("data-preorder"),
        is_back_order = $(this)
          .closest(".rebooted_grid")
          .attr("data-is_backorder"),
        pdatemeta = $(this)
          .closest(".rebooted_grid")
          .attr("data-variant_order_date"),
        btnState = $(this).closest(".rebooted_grid").attr("data-btn-disable"),
        button_text = "Add To Cart";
      if (is_pre_order == "true") {
        var preOrderdate = new Date();
        preOrderdate.setDate(preOrderdate.getDate() + 45);
        var curr_date = preOrderdate.getDate();
        var curr_month = preOrderdate.getMonth();
        curr_month++;
        var curr_year = preOrderdate.getFullYear();
        if (pdatemeta == null || pdatemeta == "") {
          pdatemeta = curr_month + "/" + curr_date + "/" + curr_year;
        }
        if (is_back_order == "true") {
          button_text = "Back-Order";
          $(".rebooted_atc_form").append(
            '<div class="preproperties"> <input type="hidden" value=' +
              pdatemeta +
              ' name="properties[EXPECTED SHIP DATE]"/> <input type="hidden" value="1" name="properties[Back-ordered items]" /></div>'
          );
        } else {
          button_text = `Προπαραγγελία`;
          $(".rebooted_atc_form").append(
            '<div class="preproperties"> <input type="hidden" value=' +
              pdatemeta +
              ' name="properties[EXPECTED SHIP DATE]"/> <input type="hidden" value="1" name="properties[Pre-ordered items]" /></div>'
          );
        }
      }
      $(".rebooted_popup_parent .rebooted_atc_btn")
        .val(button_text)
        .attr("data-lable", button_text);
      if (btnState == "true") {
        $(".rebooted_popup_parent #rebooted_atc_wrapper").html(
          '<button disabled="disabled" type="button" class="add_to_cart rebooted-cart-button">Add to cart</button>'
        );
        $(".rebooted_popup_parent #rebooted_atc_wrapper").append(
          $(".all_rebooted_items_wrpr .cartWarning").clone()
        );
      }

      if ($(".rebooted_popup_parent .left_side_bar.slick-initialized").length) {
        $(".rebooted_popup_parent .left_side_bar").slick("unslick");
      }
      $(".rebooted_popup_parent .left_side_bar").empty();

      $(".type_p").hide();
      $(".rebooted_popup").addClass("active");

      if (
        typeof all_imgs_pdp !== "undefined" &&
        typeof all_imgs_pdp[variant_title] !== "undefined"
      ) {
        if (all_imgs_pdp[variant_title].length) {
          $(all_imgs_pdp[variant_title]).each(function (ii, vv) {
            popup_data +=
              '<div class="img_wrpr"> <img class="mainImg" src="' +
              vv +
              '" data-img="' +
              vv +
              '" alt="' +
              variant_title +
              '"/></div>';
          });
        }
      }
      if (
        typeof all_video_pdp !== "undefined" &&
        typeof all_video_pdp[variant_title] !== "undefined"
      ) {
        if (all_video_pdp[variant_title].length) {
          $(all_video_pdp[variant_title]).each(function (ii, vv) {
            popup_data += '<div class="img_wrpr">' + vv + "</div>";
          });
        }
      }
      if (
        typeof all_media_pdp !== "undefined" &&
        typeof all_media_pdp[variant_title] !== "undefined"
      ) {
        if (all_media_pdp[variant_title].length) {
          $(all_media_pdp[variant_title]).each(function (ii, vv) {
            popup_data += '<div class="img_wrpr">' + vv + "</div>";
          });
        }
      }
      if (popup_data == "") {
        if ($(".productImges .featuredSlide").first().find("a").length) {
          popup_data +=
            '<div class="img_wrpr">' +
            $(".productImges .featuredSlide").first().find("a").html() +
            "</div>";
        } else {
          popup_data +=
            '<div class="img_wrpr">' +
            $(".productImges .featuredSlide").first().html() +
            "</div>";
        }
      }
      $(".rebooted_popup_parent .left_side_bar").append(popup_data);
      $(".rebooted_popup_parent .left_side_bar").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        dots: true,
      });
      $('.rebooted_popup_wrpr [name="id"]').val(
        $(this).closest(".rebooted_grid").find('[name="id"]').val()
      );
      if (cmp_variant_price > variant_price) {
        $(".rebooted_popup_wrpr .price_text").html(
          "<del>" +
            Shopify.formatMoney(cmp_variant_price, rmf) +
            "</del>" +
            Shopify.formatMoney(variant_price, rmf)
        );
      } else {
        $(".rebooted_popup_wrpr .price_text").html(
          Shopify.formatMoney(variant_price, rmf)
        );
      }
      $(".type_p.price").show();
      if ($(this).closest(".rebooted_grid").attr("data-condition") != "") {
        $(".rebooted_popup_wrpr .condition_text").html(
          $(this).closest(".rebooted_grid").attr("data-condition")
        );
        $(".type_p.condition").show();
      }
      if ($(this).closest(".rebooted_grid").attr("data-size_name") != "") {
        $(".rebooted_popup_wrpr .size_text").html(
          $(this).closest(".rebooted_grid").attr("data-size_name")
        );
        $(".type_p.size").show();
      }
      if ($(this).closest(".rebooted_grid").attr("data-color_name") != "") {
        $(".rebooted_popup_wrpr .color_text").html(
          $(this).closest(".rebooted_grid").attr("data-color_name")
        );
        $(".type_p.color").show();
      }
      if (
        $(this).closest(".rebooted_grid").attr("data-product_descripotion") !=
        ""
      ) {
        $(".rebooted_popup_wrpr .rebooted_desc").html(
          $(this).closest(".rebooted_grid").attr("data-product_descripotion")
        );
        $(".type_p.is_reboot_desc").show();
      }

      if (
        jQuery(".rebooted_popup_parent .left_side_bar.slick-initialized").length
      ) {
        jQuery(".rebooted_popup_parent .left_side_bar").slick("refresh");
      }
    }
  );

  jQuery(".rebootedimg_wrpr.set_slide").slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  var $temp_used = $("<input>");
  var $url_used = $(location).attr("href");
  $("body").on("click", ".copy_text_used", function (e) {
    e.preventDefault();
    $(".copied").remove();
    $("body").append($temp_used);
    $temp_used.val($url_used).select();
    document.execCommand("copy");
    $temp_used.remove();
    $(".copy_text_used").append('<span class="copied">Link copied</span>');
    $(".copied").addClass("active");
    setTimeout(function () {
      $(".copied").removeClass("active");
    }, 1500);
  });

  /*model js start here*/
  document.addEventListener(
    "click",
    function (e) {
      e = e || window.event;
      var target = e.target || e.srcElement;

      if (
        target.hasAttribute("data-toggle") &&
        target.getAttribute("data-toggle") == "modal"
      ) {
        if (target.hasAttribute("data-target")) {
          var m_ID = target.getAttribute("data-target");
          if ($("#" + m_ID).length > 0) {
            $("body").addClass("overflow-hidden");
            document.getElementById(m_ID).classList.add("open");
            opend_pop = target;
            document.getElementById(m_ID).focus();
            e.preventDefault();
          }
        }
      }

      // Close modal window with 'data-dismiss' attribute or when the backdrop is clicked
      if (
        (target.hasAttribute("data-dismiss") &&
          target.getAttribute("data-dismiss") == "modal") ||
        target.classList.contains("modal") ||
        target.classList.contains("close-modal")
      ) {
        if (target.classList.contains("open")) {
          $("body").removeClass("overflow-hidden");
          var modal = document.querySelector(".modal.open");
          modal.classList.remove("open");
          opend_pop = target;
          document.getElementById(m_ID).focus();
          e.preventDefault();
        }
      }
      if (
        (target.hasAttribute("data-dismiss") &&
          target.getAttribute("data-dismiss") == "modal") ||
        target.classList.contains("close-modal")
      ) {
        $("body").removeClass("overflow-hidden");
        var modal = document.querySelector(".modal.open");
        modal.classList.remove("open");
        opend_pop.focus();
        e.preventDefault();
      }
    },
    false
  );

  /*model js end here*/

  //   let $topnavBanners = $('.grid-banners-col');
  //   $topnavBanners.each(function(i, e){
  //     let $banner = $(e).find('a');
  //     let $parent = $banner.parent();
  //     let desk_src = $banner.attr('data-desk-img');
  //     let mob_src = $banner.attr('data-mob-img');
  //     let alt = $banner.attr('data-alt');
  //     $(`<picture><source media="(min-width: 767px)" srcset="${desk_src}"><img src="${mob_src}" alt="${alt}" width="400" height="400" loading="lazy"></picture>`).appendTo($banner);
  //   });

  function scroll_stick_add_to_cart() {
    if (
      $(".cutsom_button").length > 0 &&
      (window.location.href.indexOf("is_sticky_atc=true") > -1 ||
        window.sticky_add_to_cart == true)
    ) {
      $(".cutsom_button")
        .removeClass("is-visible")
        .removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();

      var elemTop = $(".cutsom_button").offset().top;
      var elemBottom = elemTop + $(".cutsom_button").height();

      if (scroll >= elemBottom) {
        $(".cutsom_button")
          .addClass("is-visible")
          .addClass("ProductStickyAddToCart");
        if ($(window).width() < 769) {
          $("body").css(
            "padding-bottom",
            $(".cutsom_button").outerHeight() + "px"
          );
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function () {
    scroll_stick_add_to_cart();
  });

  function arrow_css() {
    var height =
      $(".profiles_item.slick-slide.slick-current").height() -
      $(".profiles_item.slick-slide.slick-current")
        .find(".profile_info")
        .height();
    var divi_height =
      $(".profiles_item.slick-slide.slick-current")
        .find(".profile_info")
        .height() / 2;
    var top = height + divi_height - 30;
    $(".profiles_rows .slick-arrow").css("top", top);
  }

  $(window).on("load resize orientationchange", function () {
    $(".pride_month_page .profiles_rows").each(function () {
      var $profiles_rows = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 992) {
        if ($profiles_rows.hasClass("slick-initialized")) {
          $profiles_rows.slick("unslick");
        }
      } else {
        if (!$profiles_rows.hasClass("slick-initialized")) {
          $profiles_rows.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrow: true,
            adaptiveHeight: true,
          });
          if (
            $(".profiles_rows").closest(".disablity_pride_month_page").length >
            0
          ) {
            arrow_css();
            $profiles_rows.on("afterChange", function (ev, slick, current) {
              arrow_css();
            });
          }
        }
      }
    });
  });

  /*show truyo banner for al page start*/
  function tryou_popup(cntry = "US") {
    function show_truyo_banner() {
      if ($("#cookieSettingButton").length == 0) {
        //it doesn't exist
      } else {
        clearInterval(interval_main);
        $("#cookieSettingButton").click();
        if (cntry != "US") {
          ManageCookie("show_truyo_popup", 1, 30);
        }
      }
    }
    function change_banner_text() {
      if ($("#pane-df17c578-6785-4609-a452-835ca8f349d5").length == 0) {
        //it doesn't exist
      } else {
        clearInterval(interval_text);
        $("#pane-df17c578-6785-4609-a452-835ca8f349d5").prepend(top_text);
        $("#df17c578-6785-4609-a452-835ca8f349d5").click();
        $("#privacyPolicy").hide();
      }
    }
    var interval_text = setInterval(change_banner_text, 500);
    var interval_main = setInterval(show_truyo_banner, 500);
    var top_text =
      '<h2 style="text-align:center;font-size:16px">California Do Not “Sell” Request Center</h2><p>This Website uses cookies to improve performance, provide a world-class shopping experience and, in certain instances display more relevant Steve Madden ads to you. Some of these cookies, as defined by the CCPA, are considered a "sale" of personal information. If you would like to opt-out of the sale of these cookies and the information associated to them, you may use the toggle switch below next to "Advertising Cookies."</p><h2 style="text-align:center;font-size:16px">Manage Cookie Preferences</h2><div class="d-flex align-items-center"><div style="font-weight:500;font-size:20px">Required Cookies</div><div class="ml-5 " style="color: crimson;font-weight: bold;">Always Active</div></div></div><p>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in, or filling in forms.</p><p>You can set your browser to block or alert you about these cookies, but some parts of the site will not work.</p>';
  }

  var show_truyo_popup_cookie = getCookie("show_truyo_popup");
  if (show_truyo_popup_cookie != 1) {
    jQuery.get("/browsing_context_suggestions.json", (d) => {
      if (d.detected_values.country.handle != "US") {
        setTimeout(function () {
          tryou_popup(d.detected_values.country.handle);
        }, 3000);
      } else {
        ManageCookie("show_truyo_popup", 0);
        if (window.location.hash == "#show_popup") {
          setTimeout(function () {
            tryou_popup();
          }, 3000);
        }
      }
    });
  }
  /*show truyo banner for al page end*/

  /*collection filter on cp collection start */
  $(".advanceFiler").each(function () {
    var a = $(this).find("a");
    var tl = a.attr("title");
    a.attr("title", tl.replace("cf-size-", ""));
  });

  $(".advanceFiler").on("click", function (e) {
    var el = $(this);
    var elGroup = el.data("group");
    var elHandle = el.data("handle");
    var activeTagInGroup = $('.filterTagActive[data-group="' + elGroup + '"]');
    if (!el.hasClass("filterTagActive") && activeTagInGroup.size()) {
      e.preventDefault();
      location.href = location.href
        .replace(activeTagInGroup.data("handle"), elHandle)
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, "");
    }
  });
  /*collection filter on cp collection end */

  /* maddenqood page*/
  $(window).scroll(function () {
    if ($(".maddenwood_header_section").length > 0) {
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
        $(".maddenwood_header_right").addClass("maddenwood_header-sticky");
      } else {
        $(".maddenwood_header_right").removeClass("maddenwood_header-sticky");
      }
    }
  });
  //Bottom slider

  $(".paloma-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    dots: true,
    // adaptiveHeight: true
  });

  if ($(window).width() <= 991) {
    var video_class = "video.mobile_imgonly";
  } else {
    var video_class = "video.desktop_imgonly";
  }
  //play button
  $("body").on("click", ".main-btn.maddenwood_play_btn", function (e) {
    e.preventDefault();
    $(this)
      .closest(".maddenwood_hero_section")
      .find(".main-popup")
      .toggleClass("active");
    $("body,html").toggleClass("scrollno");
    var get_video = $(this)
      .closest(".maddenwood_hero_section")
      .find(video_class)[0];
    if (get_video.paused) {
      get_video.muted = false;
      get_video.play();
    }
  });
  $("body").on("click", ".maddednwooed_popup .close-menu", function (e) {
    e.preventDefault();
    $(".main-popup").removeClass("active");
    $("body,html").removeClass("scrollno");
    var get_video = $(this)
      .closest(".maddenwood_hero_section")
      .find(video_class)[0];
    get_video.muted = true;
    get_video.pause();
  });
  /*maddenwood end */
  $(".newnow-collection-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 581,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".api-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: parseInt($(".api-slider").attr("data-slides_count")),
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 581,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $api_slick_slider = $(".new-api-slider");
  var apisettings = {
    infinite: true,
    centerMode: false,
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
  };
  if ($window.width() <= 991) {
    $api_slick_slider.slick(apisettings);
  }
  $window.on("resize load", function () {
    if ($window.width() >= 991) {
      if ($api_slick_slider.hasClass("slick-initialized")) {
        $api_slick_slider.slick("unslick");
      }
    } else if (!$api_slick_slider.hasClass("slick-initialized")) {
      return $api_slick_slider.slick(apisettings);
    }
  });

  // if ($(window).width() <= 992) {
  //   $('.banner-api-slider').slick({
  //     dots: false,
  //     infinite: false,
  //     arrows: true,
  //     speed: 300,
  //     slidesToShow: 5,
  //     slidesToScroll: 1,
  //     swipeToSlide: true,
  //     responsive: [
  //       {
  //         breakpoint: 581,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1
  //         }
  //       },
  //       {
  //         breakpoint: 992,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 1
  //         }
  //       }
  //     ]
  //   });
  // }

  // BUNDLE PAGE JS START 02/02/23
  $("body").on("click", ".bundle_add_to_cart", function (e) {
    e.preventDefault();
    var $this = $(this).parents(".bundle_products"),
      btn_this = $(this);
    $(".Bundle_error").remove();
    $this.find(".bundle_add_error").remove();
    if (
      $(".bundle-product-card").find('.select_size input[type="radio"]:checked')
        .length < 2
    ) {
      $(this).after('<p class="Bundle_error">Please Select both Product</p>');
    } else {
      $.getJSON("/cart.json", function (cart) {
        var all_current_items = [],
          all_current_items_pid = [];
        $(cart.items).each(function (ii, cc) {
          if (typeof cc.properties["bundle_id"] !== "undefined") {
            all_current_items.push(cc.id);
            all_current_items_pid.push(cc.product_id);
          }
        });
        var JSONObj = [],
          colorobj = [];
        var total_pro = $this.find(".bundle-product-card").length;
        var selected_pro = $this
          .find(".bundle-product-card")
          .find('.swatch input[type="radio"]:checked').length;
        var uniq_id = Math.round(Date.now() / 1000);
        $this.find(".bundle-product-card").each(function (index, val) {
          var bv_id = Number($(val).find(".product_select_variant").val());
          var colid = Number($(val).attr("data-product_id"));
          if (
            all_current_items.indexOf(bv_id) > -1 ||
            all_current_items_pid.indexOf(colid) > -1
          ) {
            $(".Bundle_error").remove();
            btn_this.after(
              '<p class="Bundle_error">Selected color and size is already in cart. Please select a different color and size.</p>'
            );
            return false;
          }

          colorobj.push(colid);
          var already = false;
          // console.log($(val).parents('.bundle_card_wraper'), '4444444');
          if (
            $(val).parents(".bundle_card_wraper").attr("data-bundle") ==
            "Second"
          ) {
            JSONObj.push({
              quantity: 1,
              id: bv_id,
              properties: {
                _bundle_uniqid: "custom_bundle",
                _bundle_discount: "Yes",
                _bundle_id: uniq_id,
              },
            });
          } else {
            JSONObj.push({
              quantity: 1,
              id: bv_id,
              properties: {
                _bundle_uniqid: "custom_bundle",
                _bundle_id: uniq_id,
              },
            });
          }
        });
        if (JSONObj[0].id != JSONObj[1].id && colorobj[0] == colorobj[1]) {
          $(".Bundle_error").remove();
          btn_this.after(
            '<p class="Bundle_error">Both selected colors are same. Please select different colors to achieve bundle.</p>'
          );
          return false;
        } else if (JSONObj.length == 2) {
          jQuery
            .ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                items: JSONObj,
              },
              async: false,
              dataType: "json",
              error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR) {
                  var response = jQuery.parseJSON(jqXHR.responseText);
                  btn_this
                    .after(
                      '<p class="Bundle_error">' + response.description + "</p>"
                    )
                    .find(".error")
                    .fadeIn()
                    .delay(4000)
                    .fadeOut();
                }
                btn_this.after(
                  '<p class="Bundle_error">Something went wrong. Please try again later.</p>'
                );
              },
            })
            .done(function (data) {
              addToCartSuccess();
              $.getJSON("/cart.js", function (c) {
                $(".cartCount").text(c.item_count);
              });
              jQuery("body").addClass("cartOpen");
              jQuery(".fullPage").addClass("witmenu");
              var dataLayerUpsellProducts = [],
                createupsellDataLayerProduct = {};
              for (var i = 0; i < data.items.length; i++) {
                var IsPreOrder = false;
                var IsBackOrder = false;
                if (
                  typeof data.items[i].properties !== "undefined" &&
                  data.items[i].properties !== null &&
                  data.items[i].properties != ""
                ) {
                  if (
                    typeof data.items[i].properties["Pre-ordered items"] !==
                      "undefined" &&
                    data.items[i].properties["Pre-ordered items"] != null &&
                    data.items[i].properties["Pre-ordered items"] != ""
                  ) {
                    if (data.items[i].properties["Pre-ordered items"] == 1) {
                      IsPreOrder = true;
                    }
                  }
                  if (
                    typeof data.items[i].properties["Back-ordered items"] !==
                    "undefined"
                  ) {
                    if (data.items[i].properties["Back-ordered items"] == 1) {
                      IsBackOrder = true;
                    }
                  }
                }
                var objUpsell = {
                  id: data.items[i].product_id,
                  sku: data.items[i].variant_id,
                  style: data.items[i].sku,
                  name: data.items[i].title,
                  price: (parseInt(data.items[i].final_price) / 100).toFixed(2),
                  basePrice: (
                    parseInt(data.items[i].original_price) / 100
                  ).toFixed(2),
                  quantity: data.items[i].quantity,
                  brand: data.items[i].vendor,
                  // upc: form.find('.productbarcode').val(),
                  IsPreOrder: IsPreOrder,
                  IsBackOrder: IsBackOrder,
                  color:
                    data.items[i].options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    ) != -1
                      ? data.items[i].variant_options[
                          data.items[i].options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "color"
                          )
                        ].trim()
                      : "",
                  colorFamily:
                    data.items[i].options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "color"
                    ) != -1
                      ? data.items[i].variant_options[
                          data.items[i].options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "color"
                          )
                        ].trim()
                      : "",
                  size:
                    data.items[i].options_with_values.findIndex(
                      (x) => x["name"].toLowerCase() == "size"
                    ) != -1
                      ? data.items[i].variant_options[
                          data.items[i].options_with_values.findIndex(
                            (x) => x["name"].toLowerCase() == "size"
                          )
                        ].trim()
                      : "",
                  // expectedShipDate: form.find('.preordermessage').val()
                };
                dataLayerUpsellProducts.push(objUpsell);
              }
              if (
                dataLayerUpsellProducts.length != 0 ||
                dataLayerUpsellProducts != undefined
              ) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "addToCart",
                  addToCartLocation: "Bundle Page",
                  addToCart: {
                    name: $(".product_add_sec").data("page-handle") + " page",
                    products: dataLayerUpsellProducts,
                  },
                });
              }
              viewCartEvent();
            });
          $(".Bundle_error").remove();
          setTimeout(function () {
            upsellDatalayer();
          }, 2000);
        }
      });
    }
  });

  $("body").on("click", ".bundle-product-card .customColor", function (e) {
    e.preventDefault();
    var handle = $(this).attr("data-handle");
    var append_target = $(this).parents(".bundle_append");
    $.get("/products/" + handle + "?view=bundle_pro", function (data) {
      append_target.html(data);
      append_target.find(".product-img-wp").slick(settings);
      addclass_show();
    });
  });
  // BUNDLE PAGE JS START 02/02/23
});

// Accessibility 06-02-23
document.addEventListener("keydown", function (e) {
  if ($(e.target).closest('[role="dialog"]').length > 0) {
    const modal = $(e.target).closest('[role="dialog"]');
    const firstFocusableElement = modal.find(".first-focusable-element");
    const lastFocusableElement = modal.find(".last-focusable-element");

    let isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if ($(e.target).hasClass("first-focusable-element")) {
        lastFocusableElement.focus();
        e.preventDefault();
        return false;
      }
      if (
        $(e.target).hasClass("last-focusable-element") &&
        !modal.hasClass("cartDrawer") &&
        !modal.hasClass("navbar")
      ) {
        firstFocusableElement.focus();
        e.preventDefault();
        return false;
      }
    } else {
      if (
        $(e.target).hasClass("first-focusable-element") &&
        !modal.hasClass("cartDrawer") &&
        !modal.hasClass("navbar")
      ) {
        lastFocusableElement.focus();
        e.preventDefault();
        return false;
      }
      if ($(e.target).hasClass("last-focusable-element")) {
        firstFocusableElement.focus();
        e.preventDefault();
        return false;
      }
    }
  }
  return true;
});
function stopfocusOnBody(evt, firstElement, lastElement) {
  if (evt.key === "Tab" || evt.keyCode === 9) {
    // Tab key pressed
    if (evt.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstElement[0]) {
        evt.preventDefault();
        // Set focus on the last link
        lastElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastElement[0]) {
        evt.preventDefault();
        // Set focus on the first link
        firstElement.focus();
      }
    }
  }
}
$("#klarna-modal-overlay").on("keydown", function (evt) {
  var firstLink = $(this).find("#kl_close_klarna");
  var lastLink = $(this).find("#learn-more-close-button");
  stopfocusOnBody(evt, firstLink, lastLink);
});
$("body").on("keydown", ".zoomImgsWrap", function (evt) {
  var firstLink = $(".closeZoom");
  var lastLink = $(".zoomTo");
  stopfocusOnBody(evt, firstLink, lastLink);
});
$("body").on("keydown", ".main-quick", function (evt) {
  var firstLink = $(".close-quick");
  var lastLink = $(".see_more_details a");
  stopfocusOnBody(evt, firstLink, lastLink);
});
$("body").on("keydown", ".mobile-Navbar", function (evt) {
  // var firstLink = $('.mobile-Navbar .site-page-menu:visible li:first a');
  var firstLink = $(".mobile-site-page-menu .site-page-menu").find("a").first();
  var lastLink = $(
    ".mobile-Navbar nav[data-main-menu]:visible .site-nav > li:last-child > span.posrel"
  );
  stopfocusOnBody(evt, firstLink, lastLink);
});
$(document).ready(function () {
  // #238: remove unneccessary attributes from input search
  if ($("input#search_input").length > 0) {
    var attr = $("input#search_input").attr("role");
    var attr_aria_autocomplete =
      $("input#search_input").attr("aria-autocomplete");
    if (typeof attr !== "undefined" && attr !== false) {
      $("input#search_input").removeAttr("role");
    }
    // #11:
    if (
      typeof attr_aria_autocomplete !== "undefined" &&
      attr_aria_autocomplete !== false
    ) {
      $("input#search_input").attr("aria-autocomplete", "list");
    }
  }
  // #282: Wishlist aria labels
  function addLabels() {
    if ($(".swym-add-to-wishlist_custom").length > 0) {
      $(".quick-cart-item, .productItem").each(function (i, index) {
        if (
          $(index).find(".swym-add-to-wishlist_custom").hasClass("swym-added")
        ) {
          $(index)
            .find(".swym-add-to-wishlist_custom")
            .attr("aria-current", "true");
        } else {
          $(index)
            .find(".swym-add-to-wishlist_custom")
            .attr("aria-current", "false");
        }
      });
      setTimeout(function () {
        addLabels();
      }, 2500);
    }
  }
  addLabels();
  $("body").on("click", ".cm_addto_wishlist > a", function () {
    addLabels();
  });
  /* flaoting a label */
  $("body").on(
    "blur",
    ".floating-label input,.floating-label textarea",
    function (e) {
      if ($(this).val() == "") {
        $(this).parent("span").removeClass("no-focus");
      } else {
        $(this).parent("span").addClass("no-focus");
      }
    }
  );
  $("body").on(
    "keyup",
    ".product-single__quantity .adjust, .pdp-shop-wear, .adjust",
    function (e) {
      if (e.key === "Enter") {
        $(this).trigger("click");
      }
    }
  );

  $("body").on(
    "keyup",
    '.cartItemProducts input[name="updates[]"]',
    function (e) {
      if (e.key === "Enter") {
        $(this).trigger("click");
      }

      e.preventDefault();
      var input = $(this);
      var ip = parseInt(input.val());
      var event = "";
      var textInt = parseInt(input.val());

      if (ip == 0) {
        return false;
      }

      //----------------10 Max Qty--------------------------
      var cartTotal = 0;
      $(".cartItemProducts input[name='updates[]']").each(function () {
        cartTotal += parseInt($(this).val());
      });

      if (cartTotal > 10) {
        if (jQuery(".restrictAddToCartError").length == 0) {
          jQuery("#cartform").prepend(
            '<span id="restrictAddToCartError" class="one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
          );
          jQuery(".purchase").prepend(
            '<span id="restrictAddToCartError" class="four restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
          );
        }

        ip = textInt;

        return false;
      } else {
        jQuery(".restrictAddToCartError").remove();
      }
      //--------------------10 Max Qty------------------------------
      input.val(ip);
      var li = input.data("line");
      var id = parseInt(input.attr("data-id"));
      var item = [];
      $.getJSON("/cart.js", function (cart) {
        var c = $(cart.items).filter(function (index, cont) {
          return cont.id == id;
        });
        item.push(c[0]);
      });
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { line: li, quantity: ip },
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown) {
          // var response = jQuery.parseJSON(jqXHR.responseText);
          console.log(jqXHR);
          // location.reload();
        },
        success: function (data) {
          //    setTimeout(function() {
          //      item_count(item[0], event, ip);
          //    }, 1000);
          setTimeout(function () {
            $(".wishlist_mini .swym-loaded").css("visibility", "visible");
          }, 1000);
        },
      });
    }
  );

  $("body").on("click", "#closeIconContainer", function () {
    $("body").focus();
  });
  $("body").on("keydown", ".click_trigger_swatch", function (e) {
    if (e.keyCode === 13) {
      $(this).find("label").trigger("click");
    }
  });
  $("body").on("click", ".open-cookie-popup", function (e) {
    e.preventDefault();
    $("#ot-sdk-btn").trigger("click");
  });
  if (window.location.href.indexOf("do-not-sell-my-personal-data") > -1) {
    if (localStorage.getItem("doo") == null) {
      setTimeout(function () {
        localStorage.setItem("doo", "yes");
        $("#ot-sdk-btn").trigger("click");
      }, 2500);
    }
  } else {
    localStorage.removeItem("doo");
  }

  // Accessibility 05-05-23
  $("body").on("click", ".rotation-button", function (e) {
    if ($(this).hasClass("is-playing")) {
      $(this)
        .removeClass("is-playing")
        .addClass("is-stoped")
        .find(".pause-container")
        .addClass("is-hide");
      $(".sq_insta_wp").slick("slickPause");
      $(this).find(".resume-container").removeClass("is-hide");
    } else {
      $(this)
        .removeClass("is-stoped")
        .addClass("is-playing")
        .find(".pause-container")
        .removeClass("is-hide");
      $(".sq_insta_wp").slick("slickPlay");
      $(this).find(".resume-container").addClass("is-hide");
    }
  });
  function addYotpoLabel() {
    if (
      $("body").hasClass("template-product") &&
      $(".yotpo-widget-instance").length != 0 &&
      $("#yotpo-reviews-main-widget").length != 0
    ) {
      $("#yotpo-reviews-main-widget").attr({
        role: "region",
        "aria-label": "product reviews",
      });
    } else {
      setTimeout(addYotpoLabel, 200);
    }
  }
  addYotpoLabel();
  function addPaymentButtons() {
    if ($('[data-shopify-buttoncontainer="true"]').length != 0) {
      $('[data-shopify-buttoncontainer="true"]')
        .find("svg")
        .attr("aria-hidden", true);
    } else {
      setTimeout(addPaymentButtons, 200);
    }
  }
  addPaymentButtons();
});

$(window).on("resize load", function () {
  if ($(window).width() < 767) {
    $(".mobile-Navbar").attr({
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "mobile-menu-title",
      tabindex: "-1",
    });
    if ($(".mobile-Navbar #mobile-menu-title").length == 0)
      $("#mainNavDesk").prepend(
        '<h1 id="mobile-menu-title" class="sr-only">Mobile menu</h1>'
      );
  } else {
    $(".mobile-Navbar").removeAttr("role aria-modal aria-labelledby");
    $(".mobile-Navbar #mobile-menu-title").remove();
  }
});

$("body").on("keydown", ".swatch-element", function (e) {
  var thisIndex = parseInt($(this).data("idx")),
    total_length = $(this)
      .parents(".swatch_elements_wrapper")
      .find(".swatch-element").length;
  $(".new_custom_swatch_Size .swatch-element").attr({
    tabindex: "-1",
    "aria-checked": false,
  });
  if (e.keyCode === 37 || e.keyCode === 38) {
    // left & up
    var prev = thisIndex - 1;
    if (
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="' + prev + '"]').length > 0
    ) {
      if ($(this).parents(".new_custom_swatch_Size").length > 0)
        $(this)
          .parents(".swatch_elements_wrapper")
          .find('.swatch-element[data-idx="' + prev + '"]')
          .find('input[type="radio"]')
          .trigger("click");
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="' + prev + '"]')
        .attr({ tabindex: "0", "aria-checked": true })
        .focus();
    } else {
      if ($(this).parents(".new_custom_swatch_Size").length > 0)
        $(this)
          .parents(".swatch_elements_wrapper")
          .find('.swatch-element[data-idx="' + total_length + '"]')
          .find('input[type="radio"]')
          .trigger("click");
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="' + total_length + '"]')
        .attr({ tabindex: "0", "aria-checked": true })
        .focus();
    }
  } else if (e.keyCode === 39 || e.keyCode === 40) {
    // right & down
    var next = thisIndex + 1;
    if (
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="' + next + '"]').length > 0
    ) {
      if ($(this).parents(".new_custom_swatch_Size").length > 0)
        $(this)
          .parents(".swatch_elements_wrapper")
          .find('.swatch-element[data-idx="' + next + '"]')
          .find('input[type="radio"]')
          .trigger("click");
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="' + next + '"]')
        .attr({ tabindex: "0", "aria-checked": true })
        .focus();
    } else {
      if ($(this).parents(".new_custom_swatch_Size").length > 0)
        $(this)
          .parents(".swatch_elements_wrapper")
          .find('.swatch-element[data-idx="1"]')
          .find('input[type="radio"]')
          .trigger("click");
      $(this)
        .parents(".swatch_elements_wrapper")
        .find('.swatch-element[data-idx="1"]')
        .attr({ tabindex: "0", "aria-checked": true })
        .focus();
    }
  }
  if (e.keyCode === 13) {
    $(this).find('input[type="radio"]').trigger("click");
  }
});

if ($(".pdp-main-img.desktopOnly .image_wrapper_div").length > 0) {
  $(".pdp-main-img.desktopOnly .image_wrapper_div").slick({
    infinite: false,
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: false,
  });
}
// Accessibility 06-02-23

const scrollToSection = () => {
  if (window.location.href.indexOf("#gallery_") > -1) {
    var sectionID = "#gallery_" + window.location.href.split("#gallery_")[1],
      headerHeight = $(".ais-search-query").outerHeight();
    if (
      $(sectionID).length > 0 &&
      $(sectionID).next(".stylistic_widget_wrap").children().length > 0
    ) {
      var of =
        $(sectionID).next(".stylistic_widget_wrap").offset().top - headerHeight;
      $("html,body").animate({ scrollTop: of }, 500);
    } else {
      setTimeout(scrollToSection, 200);
    }
  }
};

$(document).ready(function () {
  var windowSize = $(window).width();
  if (windowSize <= 767) {
    $(".discount-grid-row").slick({
      infinite: true,
      arrows: true,
      dots: false,
      autoplay: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  scrollToSection(); // stylistic widget
});
$(window).on("load", function () {
  scrollToSection(); // stylistic widget
});

// -------------------------Max 10 Qty Code Start---------------------------------------------------

function AddToCartQuantityMaxLimit() {
  var quantity = $("#quantity").val();

  var _count = 0;

  if (ShopCart != null && ShopCart.count != null) {
    _count = parseInt(ShopCart.count);
  }

  var totalCart = _count;
  if (typeof quantity != "undefined" && quantity != "") {
    totalCart += parseInt(quantity);
  }
  if (
    (totalCart > 10 && jQuery(".swym-wishlist-detail-header").length == 0) ||
    (totalCart >= 10 && jQuery(".swym-wishlist-detail-header").length > 0)
  ) {
    if (jQuery(".restrictAddToCartError").length == 0) {
      jQuery(".purchase").prepend(
        '<span  class="four restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery("#cartform").prepend(
        '<span  class="one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery(".swym-wishlist-detail-header").prepend(
        '<span  class="wishlist-one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
    }

    return true;
  } else {
    jQuery(".restrictAddToCartError").remove();
    return false;
  }
}
function AjaxAddToCartQuantityMaxLimit(elementClass) {
  var totalCart = 0;

  jQuery(".cartDrawer .quantity").each(function () {
    totalCart += parseInt(jQuery(this).val());
  });

  if (
    elementClass == "plus" &&
    (totalCart > 9 || parseInt(ShopCart.count) > 9)
  ) {
    if (jQuery("#ajax-restrictAddToCartError").length == 0) {
      if (jQuery(".restrictAddToCartError").length == 0) {
        jQuery(".purchase").prepend(
          '<span  class="four-ajax restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
        );
        jQuery(".swym-wishlist-detail-header").prepend(
          '<span  class="wishlist-one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
        );
      }
      jQuery("#crt").prepend(
        '<span id="ajax-restrictAddToCartError" class="two restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
    }

    return true;
  } else {
    jQuery("#ajax-restrictAddToCartError").remove();
    jQuery(".restrictAddToCartError").remove();
    return false;
  }
}
function ProcessCartResponseMaxLimit(splittedUrl, responseText) {
  if (splittedUrl != "undefined" && splittedUrl != "" && splittedUrl != null) {
    splittedUrl = splittedUrl.split("?");
    if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
      var response = JSON.parse(responseText);
      ShopCart.count = response.item_count;
      console.log("ShopCart.count");
      console.log(ShopCart.count);
      if (ShopCart.count < 10) {
        jQuery("#ajax-restrictAddToCartError").remove();
        jQuery(".restrictAddToCartError").remove();
      }
    }
  }
}
function CheckMaxCart() {
  var result = true;
  if (ShopCart.count < 10) {
    jQuery("#ajax-restrictAddToCartError").remove();
    jQuery("#restrictAddToCartError").remove();
  } else {
    result = false;
    if (jQuery(".restrictAddToCartError").length == 0) {
      jQuery("#cartform").prepend(
        '<span  class="CheckMaxCart restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery(".purchase").prepend(
        '<span  class="CheckMaxCart restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery(".swym-wishlist-detail-header").prepend(
        '<span  class="wishlist-one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
    }

    if (jQuery("#ajax-restrictAddToCartError").length == 0) {
      jQuery("#crt").prepend(
        '<span id="ajax-restrictAddToCartError" class="two restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
    }
  }
  return result;
}

$("#cartform #checkout").on("click", function () {
  var totalCart = 0;
  $('.product-single__quantity input[name="updates[]"]').each(function () {
    totalCart += parseInt($(this).val());
  });

  if (totalCart > 10) {
    event.preventDefault();
    if (jQuery(".restrictAddToCartError").length == 0) {
      jQuery("#cartform").prepend(
        '<span  class="one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery(".purchase").prepend(
        '<span  class="four restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
      jQuery(".swym-wishlist-detail-header").prepend(
        '<span  class="wishlist-one restrictAddToCartError" style="color:red;display:block">We&#39;re sorry, we only allow a maximum of 10 items per order. </span>'
      );
    }
  } else {
    jQuery(".restrictAddToCartError").remove();
  }
});

jQuery(document).ajaxComplete(function (event, xhr, settings = {}) {
  var splittedUrl = settings.url;
  if (splittedUrl != "undefined" && splittedUrl != "" && splittedUrl != null) {
    splittedUrl = splittedUrl.split("?");
    if (
      splittedUrl[0] == "/gatedToken.js" ||
      (splittedUrl[0] == "/cart/change.js" &&
        xhr.readyState == 4 &&
        xhr.status == 200)
    ) {
      try {
        ProcessCartResponseMaxLimit(settings.url, xhr.responseText);
      } catch (e) {}

      try {
        if (typeof ProcessCartResponse === "function") {
          ProcessCartResponse(settings.url, xhr.responseText);
        }
      } catch (e) {}
    }
  }
});

// ------------------------------------------Max 10 Qty Code END---------------------------------------------------
